export const services = [
  {
    "Name": "Digital Ocean",
    "Approved": "Yes",
    "Category": "Hosting",
    "URL": "https://digitalocean.com",
    "Description": "Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.",
    "Discount": "$1,000",
    "Does it drive you into a paid account": "Maybe, but you can get pretty far with $1000.",
    "Requirement": "Expires one year after it is issued",
    "Favicon": "",
    "How to apply (text)": "Fill in their form on a special page",
    "How to apply (URL or email)": "https://www.digitalocean.com/community/pages/covid-19",
    "More info URL": ""
  },
  {
    "Name": "Intercom",
    "Approved": "Yes",
    "Category": "Website Tools",
    "URL": "https://intercom.com",
    "Description": "Intercom helps over 25,000 global organizations deliver better customer support via personalized conversations and automated support.",
    "Discount": "100%",
    "Does it drive you into a paid account": "Maybe, you need to enter payment information and will be charged automatically after 2 years.",
    "Requirement": "Free of charge to any company or institution fighting COVID-19 and its impact on society, or working to help those affected.",
    "Favicon": "https://www.intercom.com/_next/static/images/apple-touch-icon-iphone-eb1b3768428e86b06930fbfc4b7fabbe.png",
    "How to apply (text)": "Use chatbot on the page",
    "How to apply (URL or email)": "https://www.intercom.com/partner/covid-19-information",
    "More info URL": ""
  },
  {
    "Name": "Airtable",
    "Approved": "Yes",
    "Category": "Website Tools",
    "URL": "https://airtable.com",
    "Description": "Airtable is a low-code platform for building collaborative apps. Customize your workflow, collaborate, and achieve ambitious outcomes. Get started for free.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No, no need for payment information and 1 year free trial",
    "Requirement": "Airtable is making Airtable Pro available for free to any non-political humanitarian group that is working on COVID-19 relief efforts.",
    "Favicon": "https://airtable.com/images/favicon/baymax/apple-touch-icon.png",
    "How to apply (text)": "Fill out form on the right",
    "How to apply (URL or email)": "https://airtable.com/covid19",
    "More info URL": "https://blog.airtable.com/airtables-support-for-covid-19-response-efforts/"
  },
  {
    "Name": "Divjoy",
    "Approved": "Yes",
    "Category": "Website Tools",
    "URL": "https://divjoy.com",
    "Description": "Divjoy helps you create the perfect codebase and UI for your next React project.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No, no need for payment information and 1 year free usage.",
    "Requirement": "It's appreciated to add a link back to divjoy.com (not required). Free for Covid-19 projects.",
    "Favicon": "/static/images/favicon/apple-touch-icon.png",
    "How to apply (text)": "Use chatbot on the page",
    "How to apply (URL or email)": "https://divjoy.com/",
    "More info URL": ""
  },
  {
    "Name": "Leverice",
    "Approved": "Yes",
    "Category": "Remote Work",
    "URL": "https://leverice.com",
    "Description": "A team messenger that lets you focus on what matters.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "",
    "Favicon": "",
    "How to apply (text)": "Click on \"Get Started\" or \"Try Now\" button on homepage.",
    "How to apply (URL or email)": "https://leverice.com",
    "More info URL": ""
  },
  {
    "Name": "Sheet2Site",
    "Approved": "Yes",
    "Category": "Website Builder",
    "URL": "https://sheet2site.com",
    "Description": "Create a website from Google Sheets",
    "Discount": "100%",
    "Does it drive you into a paid account": "No, but this free plan has no custom domain.",
    "Requirement": "Install add-on",
    "Favicon": "../img/faviconnew.png",
    "How to apply (text)": "Use the button below",
    "How to apply (URL or email)": "https://sheet2site.com/coronavirus",
    "More info URL": ""
  },
  {
    "Name": "Sparkly",
    "Approved": "Yes",
    "Category": "Slack App",
    "URL": "https://sparklybot.com",
    "Description": "Match people in your Slack space that have similar expertise or interest so they can share information related to COVID-19.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "",
    "Favicon": "resources/favicon.ico",
    "How to apply (text)": "Email: erwin@sparklybot.com",
    "How to apply (URL or email)": "erwin@sparklybot.com",
    "More info URL": "https://sparklybot.com"
  },
  {
    "Name": "Mindwave for Teams",
    "Approved": "Yes",
    "Category": "Writing Tools",
    "URL": "https://mindwave.app",
    "Description": "Mindwave is a journal app for work & life. Together you'll learn from the past, be present and improve the future.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No, you get an extended free trial (6 months), no credit card needed.",
    "Requirement": "COVID-19 projects, or anyone who can't afford it (literally or mentally)",
    "Favicon": "https://mindwave.app/assets/favicons/apple-touch-icon.png",
    "How to apply (text)": "Email: support@mindwave.app",
    "How to apply (URL or email)": "support@mindwave.app",
    "More info URL": "https://mindwave.app/stories/covid-19-and-my-tiny-contribution-LVjv0V"
  },
  {
    "Name": "Pigeon",
    "Approved": "Yes",
    "Category": "CRM",
    "URL": "https://trypigeon.co",
    "Description": "Gmail, meet spreadsheet. CRM, mail merge, automated follow ups, canned responses, and many more features to spend less time on email.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Your business has been substantially affected by COVID-19",
    "Favicon": "",
    "How to apply (text)": "Install Chrome extension @ https://trypigeon.co",
    "How to apply (URL or email)": "pat@trypigeon.co",
    "More info URL": ""
  },
  {
    "Name": "Spike.sh",
    "Approved": "Yes",
    "Category": "Incident Management",
    "URL": "https://spike.sh",
    "Description": "Spike is a simple incident management platform that alerts via slack, phone and email and automatic escalations to help teams fix infrastructure problems.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Free for COVID-19 projects",
    "Favicon": "/spike-badge-180.png",
    "How to apply (text)": "Signup & email us covid19@spike.sh",
    "How to apply (URL or email)": "covid19@spike.sh",
    "More info URL": ""
  },
  {
    "Name": "Outline",
    "Approved": "Yes",
    "Category": "Writing Tools",
    "URL": "https://www.getoutline.com",
    "Description": "A modern team knowledge base for your internal documentation, product specs, support answers, meeting notes, onboarding, & more…",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "COVID-19 projects. Discounts available for affected industries",
    "Favicon": "",
    "How to apply (text)": "Email: hello@getoutline.com",
    "How to apply (URL or email)": "hello@getoutline.com",
    "More info URL": ""
  },
  {
    "Name": "Lowdown",
    "Approved": "Yes",
    "Category": "Email",
    "URL": "https://getlowdown.com",
    "Description": "Lowdown gives each of your Slack community members a custom email digest. The channels they care about delivered, daily, weekly or monthly directly to their inboxes. So they don't miss out.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Free for Slack groups helping with COVID-19",
    "Favicon": "/icons/icon-48x48.png?v=cbf83db1d7076e7706531a225f915b35",
    "How to apply (text)": "Sign up and then send us an email.",
    "How to apply (URL or email)": "https://getlowdown.com/covid-19/",
    "More info URL": ""
  },
  {
    "Name": "Productroad",
    "Approved": "Yes",
    "Category": "Productivity Tools",
    "URL": "https://productroad.com",
    "Description": "Customer feedback management",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "",
    "Favicon": "https://productroad.com/static/images/favicon/productroad-64x64.png",
    "How to apply (text)": "Contact in livechat",
    "How to apply (URL or email)": "https://productroad.com",
    "More info URL": ""
  },
  {
    "Name": "Simple Analytics",
    "Approved": "Yes",
    "Category": "Analytics",
    "URL": "https://simpleanalytics.com",
    "Description": "Simple Analytics is the privacy-first Google Analytics alternative that is 100% GDPR compliant. Give us a try!",
    "Discount": "100%",
    "Does it drive you into a paid account": "No, you don't have to enter any payment information.",
    "Requirement": "Public stats + link in footer of project",
    "Favicon": "/apple-touch-icon.png",
    "How to apply (text)": "Fill in their contact form or use their chat widget",
    "How to apply (URL or email)": "https://simpleanalytics.com/contact",
    "More info URL": ""
  },
  {
    "Name": "Kedaiweb",
    "Approved": "Yes",
    "Category": "eCommerce Software",
    "URL": "https://kedaiweb.co",
    "Description": "The ecommerce system comes with four pre-built agent to help you get started faster · Kedaiweb.co",
    "Discount": "70%",
    "Does it drive you into a paid account": "Maybe",
    "Requirement": "",
    "Favicon": "https://kedaiweb.co/4/favicon-32x32.png",
    "How to apply (text)": "Signup & all addon up to 70% discount",
    "How to apply (URL or email)": "https://kedaiweb.co",
    "More info URL": ""
  },
  {
    "Name": "Remote OK",
    "Approved": "Yes",
    "Category": "Remote Work",
    "URL": "https://remoteok.io",
    "Description": "Hire the best remote working talent in the world on Remote OK and reach millions of applicants, just like Amazon, Microsoft, Stripe, ESPN, Intercom, GoDaddy, Namecheap, Invision, Toptal and thousands more remote companies.",
    "Discount": "Job posting for $3",
    "Does it drive you into a paid account": "Maybe, with the upsells.",
    "Requirement": "Disable logo options to get full discount.",
    "Favicon": "/assets/apple-icon-57x57.png?2",
    "How to apply (text)": "Just post a job",
    "How to apply (URL or email)": "https://remoteok.io/hire-remotely",
    "More info URL": ""
  },
  {
    "Name": "Stadia Maps",
    "Approved": "Yes",
    "Category": "Website Tools",
    "URL": "https://stadiamaps.com",
    "Description": "Location made human: Map tiles, static maps, and routing for every app.",
    "Discount": "50-100%",
    "Does it drive you into a paid account": "Maybe",
    "Requirement": "Attribution in maps",
    "Favicon": "https://stadiamaps.com/favicon-32x32.png",
    "How to apply (text)": "Email: info@stadiamaps.com",
    "How to apply (URL or email)": "info@stadiamaps.com",
    "More info URL": ""
  },
  {
    "Name": "blucheq",
    "Approved": "Yes",
    "Category": "Project Management",
    "URL": "https://blucheq.com",
    "Description": "We help online businesses comply with privacy regulations like the GDPR and CCPA, including EU representation per GDPR's Article 27",
    "Discount": "50-100%",
    "Does it drive you into a paid account": "Maybe",
    "Requirement": "Attribution on project website.",
    "Favicon": "https://blucheq.com/apple-touch-icon.png",
    "How to apply (text)": "E-mail: covid@blucheq.com",
    "How to apply (URL or email)": "covid@blucheq.com",
    "More info URL": "https://blucheq.com"
  },
  {
    "Name": "Project Central",
    "Approved": "Yes",
    "Category": "Project Management",
    "URL": "https://www.projectcentral.com",
    "Description": "",
    "Discount": "50%",
    "Does it drive you into a paid account": "No, after 14-day free trial expires and it will then prompt for payment information.",
    "Requirement": "Users need a Microsoft Work account",
    "Favicon": "",
    "How to apply (text)": "Email support@projectcentral.com to receive discount code",
    "How to apply (URL or email)": "support@projectcentral.com",
    "More info URL": ""
  },
  {
    "Name": "Remote Leaf",
    "Approved": "Yes",
    "Category": "Remote Work",
    "URL": "https://remoteleaf.com",
    "Description": "",
    "Discount": "50%",
    "Does it drive you into a paid account": "Maybe",
    "Requirement": "",
    "Favicon": "https://remoteleaf.com/static/leaf/img/leaf/Favicon%402x.png",
    "How to apply (text)": "Email: abi@remoteleaf.com",
    "How to apply (URL or email)": "abi@remoteleaf.com",
    "More info URL": ""
  },
  {
    "Name": "Burner Mail",
    "Approved": "Yes",
    "Category": "Email",
    "URL": "https://burnermail.io",
    "Description": "",
    "Discount": "50%",
    "Does it drive you into a paid account": "Maybe, the discount is only applied to the first charge but it's possible to select 3 years. It will renew with normal pricing.",
    "Requirement": "",
    "Favicon": "https://burnermail.io/favicon-196x196.png",
    "How to apply (text)": "Using coupon code: STAYINGHOME",
    "How to apply (URL or email)": "https://burnermail.io",
    "More info URL": ""
  },
  {
    "Name": "DarwinMail",
    "Approved": "Yes",
    "Category": "Email",
    "URL": "https://www.darwinmail.app",
    "Description": "DarwinMail is your golden ticket to a more productive day.",
    "Discount": "50%",
    "Does it drive you into a paid account": "Maybe",
    "Requirement": "",
    "Favicon": "https://www.darwinmail.app/mail/lib/manifest/apple-touch-icon.png",
    "How to apply (text)": "Sign up and then send us an email.",
    "How to apply (URL or email)": "https://www.darwinmail.app/mail",
    "More info URL": ""
  },
  {
    "Name": "FindMeGigs",
    "Approved": "Yes",
    "Category": "Remote Work",
    "URL": "https://findmegigs.com",
    "Description": "Bot that finds you jobs on Twitter",
    "Discount": "30%",
    "Does it drive you into a paid account": "Maybe",
    "Requirement": "",
    "Favicon": "/assets/images/apple-touch-icon.png?v20453383585851",
    "How to apply (text)": "Just sign up using this link",
    "How to apply (URL or email)": "https://findmegigs.com/#job-seeker-plan-discounted",
    "More info URL": ""
  },
  {
    "Name": "Xeovo",
    "Approved": "Yes",
    "Category": "VPN",
    "URL": "https://xeovo.com",
    "Description": "Silence censorship. Protect your privacy and bypass restrictions with Xeovo VPN.",
    "Discount": "30%",
    "Does it drive you into a paid account": "Maybe",
    "Requirement": "",
    "Favicon": "https://xeovo.com/static/favicon.3fbbff7e00cb.ico",
    "How to apply (text)": "Use this code: StayHome2020",
    "How to apply (URL or email)": "https://xeovo.com",
    "More info URL": ""
  },
  {
    "Name": "Proxyman",
    "Approved": "Yes",
    "Category": "Developer Tools",
    "URL": "https://proxyman.io",
    "Description": "Modern and Delightful HTTP Debugging Proxy. Proxyman is a high-performance macOS app, which enables developers to view HTTP/HTTPS requests from apps and domains from macOS & iPhone & Android",
    "Discount": "30%",
    "Does it drive you into a paid account": "Maybe, it's a discount",
    "Requirement": "",
    "Favicon": "/favicon/apple-icon-57x57.png",
    "How to apply (text)": "Coupon: PROXYMAN_STAY_SAFE_STAY_HEALTHY",
    "How to apply (URL or email)": "https://proxyman.io/pricing",
    "More info URL": ""
  },
  {
    "Name": "Polypane",
    "Approved": "Yes",
    "Category": "Developer Tools",
    "URL": "https://polypane.app",
    "Description": "A web browser for developers and designers that makes you twice as productive",
    "Discount": "100%",
    "Does it drive you into a paid account": "No, no need for payment information and 6 months free usage.",
    "Requirement": "To use for a covid-related site or tool, link back appreciated.",
    "Favicon": "/icons/icon-48x48.png?v=5df5528946772487a6ab462ff2125f26",
    "How to apply (text)": "Email: support@polypane.app",
    "How to apply (URL or email)": "support@polypane.app",
    "More info URL": "https://polypane.app"
  },
  {
    "Name": "FunRetro",
    "Approved": "Yes",
    "Category": "Remote Work",
    "URL": "http://funretro.io",
    "Description": "Collaboration tool for remote teams to do agile retrospectives and other activities/meetings.",
    "Discount": "25%",
    "Does it drive you into a paid account": "Maybe",
    "Requirement": "",
    "Favicon": "https://funretro.io/apple-touch-icon.png",
    "How to apply (text)": "Email: info@funretro.io",
    "How to apply (URL or email)": "info@funretro.io",
    "More info URL": ""
  },
  {
    "Name": "JustCall",
    "Approved": "Yes",
    "Category": "Website Tools",
    "URL": "https://justcall.io",
    "Description": "JustCall is a cloud based business phone system for remote sales and customer support teams.Sign up for a free trial to use an international phone number to call customers remotely in seconds.",
    "Discount": "20%",
    "Does it drive you into a paid account": "Maybe",
    "Requirement": "20% off on subscription plans for 6 months. 70% off 1st month.",
    "Favicon": "https://justcall.io/favicon.png",
    "How to apply (text)": "Signup & automatically get 70% off. Ping chat support for 20% for 6 months.",
    "How to apply (URL or email)": "help@justcall.io",
    "More info URL": ""
  },
  {
    "Name": "Helpwise",
    "Approved": "Yes",
    "Category": "Email",
    "URL": "https://helpwise.io",
    "Description": "Customer service platform for SMBs to help you serve customers faster and retain them better. Helpwise empowers agents to serve customers not tickets.",
    "Discount": "20%",
    "Does it drive you into a paid account": "Maybe",
    "Requirement": "20% off for 12 months",
    "Favicon": "https://cdn.helpwise.io/assets/images/favicon.png",
    "How to apply (text)": "Signup & upgrade. Ping support for 20% off for 12 months.",
    "How to apply (URL or email)": "https://helpwise.io",
    "More info URL": ""
  },
  {
    "Name": "Reader Mode Premium",
    "Approved": "Yes",
    "Category": "Productivity Tools",
    "URL": "https://readermode.io",
    "Description": "",
    "Discount": "20%",
    "Does it drive you into a paid account": "Maybe",
    "Requirement": "",
    "Favicon": "/apple-touch-icon.png",
    "How to apply (text)": "Use coupon code: stayathome",
    "How to apply (URL or email)": "https://readermode.io/premium",
    "More info URL": ""
  },
  {
    "Name": "Publisuites",
    "Approved": "Yes",
    "Category": "Ads",
    "URL": "https://www.publisuites.com",
    "Description": "Sign up as a free advertiser and improve your content marketing with sponsored posts and texts for SEO",
    "Discount": "15% extra",
    "Does it drive you into a paid account": "Maybe, it's an extra discount",
    "Requirement": "Additional 15% of credit in the rechargings by applying coupon CSVCOVID.\nOnly for advertisers counts.",
    "Favicon": "",
    "How to apply (text)": "Using coupon code: CSVCOVID",
    "How to apply (URL or email)": "https://www.publisuites.com/en/info-advertisers/",
    "More info URL": ""
  },
  {
    "Name": "Retrospect.team",
    "Approved": "Yes",
    "Category": "Remote Work",
    "URL": "https://www.retrospect.team",
    "Description": "Easily conduct end of sprint and project retrospectives with everyone on your team no matter their location.",
    "Discount": "Lifetime for $48, rather than $4/mo. ongoing.",
    "Does it drive you into a paid account": "No, but you have to pay a one time fee.",
    "Requirement": "",
    "Favicon": "/apple-touch-icon.png",
    "How to apply (text)": "Signup & upgrade to PRO Lifetime Account for $48.",
    "How to apply (URL or email)": "https://www.retrospect.team/",
    "More info URL": ""
  },
  {
    "Name": "Leave Me Alone",
    "Approved": "Yes",
    "Category": "Productivity Tools",
    "URL": "https://leavemealone.app",
    "Description": "Manage your email subscriptions in a single click. Discover how to unsubscribe from emails you don't want using Leave Me Alone. Try our tool for free!",
    "Discount": "Free 50 credits",
    "Does it drive you into a paid account": "Maybe, but you will not be automatically charged.",
    "Requirement": "",
    "Favicon": "/favicons/apple-icon-57x57.png",
    "How to apply (text)": "Use coupon: HELPING_HAND on profile billing page",
    "How to apply (URL or email)": "https://leavemealone.app/signup",
    "More info URL": ""
  },
  {
    "Name": "Grow.com",
    "Approved": "Yes",
    "Category": "Business Intelligence",
    "URL": "https://www.grow.com",
    "Description": "Business intelligence software that frees the insights you desperately need to fuel growth and transform your business.",
    "Discount": "Free 1 dashboard",
    "Does it drive you into a paid account": "Maybe, with the upsells.",
    "Requirement": "Free 1 dashboard for 12 months.",
    "Favicon": "https://global-uploads.webflow.com/5bc779c7cb6515eacd17ad0f/5be5b664be7e638f340f9531_grow-webclip.png",
    "How to apply (text)": "Fill out form on landing page",
    "How to apply (URL or email)": "https://www.grow.com/free-business-intelligence-spreadsheet-dashboard",
    "More info URL": ""
  },
  {
    "Name": "CLINQ",
    "Approved": "Yes",
    "Category": "Remote Work",
    "URL": "https://clinq.com",
    "Description": "Slack-Like Business Telephonie for Teams. Each channel has an own phone number for incoming and outgoing calls.",
    "Discount": "600 free minutes per user",
    "Does it drive you into a paid account": "Maybe, but you will not be automatically charged.",
    "Requirement": "",
    "Favicon": "https://clinq.com/wp-content/uploads/2021/08/favicon-300x300.png",
    "How to apply (text)": "No application needed",
    "How to apply (URL or email)": "https://clinq.com/en/",
    "More info URL": ""
  },
  {
    "Name": "PagerTree",
    "Approved": "Yes",
    "Category": "Incident Management",
    "URL": "https://pagertree.com",
    "Description": "PagerTree on-call incident management gives devops teams flexible schedules, escalations, & reliable notifications via email, SMS, voice, & smartphone app.",
    "Discount": "3 months $3",
    "Does it drive you into a paid account": "Yes, but you can cancel your subscription any time.",
    "Requirement": "",
    "Favicon": "",
    "How to apply (text)": "Email: support@pagertree.com",
    "How to apply (URL or email)": "support@pagertree.com",
    "More info URL": ""
  },
  {
    "Name": "SafeRequest",
    "Approved": "Yes",
    "Category": "Productivity Tools",
    "URL": "https://saferequest.net",
    "Description": "",
    "Discount": "3 months for €3",
    "Does it drive you into a paid account": "Yes, but you can cancel your subscription any time.",
    "Requirement": "",
    "Favicon": "",
    "How to apply (text)": "Signup, become a pro, use coupon code covid-19",
    "How to apply (URL or email)": "https://saferequest.net/en/pricing",
    "More info URL": ""
  },
  {
    "Name": "NetNut",
    "Approved": "",
    "Category": "Data collection",
    "URL": "https://netnut.io/",
    "Description": "NetNut is the fastest residential proxy network for businesses. Gather any web data & never get blocked again.",
    "Discount": "50% for all packages",
    "Does it drive you into a paid account": "Maybe",
    "Requirement": "New customers",
    "Favicon": "https://cdn.shortpixel.ai/spai/q_lossy+ret_img+to_webp/https://netnut.io/wp-content/uploads/2020/04/cropped-Favicon-transparent-180x180.png",
    "How to apply (text)": "Email jeffy@netnut.io",
    "How to apply (URL or email)": "https://l.netnut.io/saasforcovid",
    "More info URL": "https://netnut.io/"
  },
  {
    "Name": "Webflow",
    "Approved": "Yes",
    "Category": "Website Builder",
    "URL": "https://webflow.com",
    "Description": "Site builder and hosting.",
    "Discount": "12 months hosting",
    "Does it drive you into a paid account": "Maybe, after the 12 months.",
    "Requirement": "",
    "Favicon": "https://assets-global.website-files.com/5d3e265ac89f6a3e64292efc/5d5595354de4fbdd8c554dba_default_webclip.png",
    "How to apply (text)": "Contact support with details of project for discount code.",
    "How to apply (URL or email)": "https://university.webflow.com/support#contact-form",
    "More info URL": ""
  },
  {
    "Name": "IBM Cloud",
    "Approved": "Yes",
    "Category": "Developer Tools",
    "URL": "https://www.ibm.com",
    "Description": "To meet the global challenge of COVID-19, the world must come together. IBM has resources to share — like supercomputing power, virus tracking and an AI assistant to answer citizens’ questions.",
    "Discount": "3 months free",
    "Does it drive you into a paid account": "Maybe, after the 3 months.",
    "Requirement": "",
    "Favicon": "//www.ibm.com/favicon.ico",
    "How to apply (text)": "Use the form on their page.",
    "How to apply (URL or email)": "https://www.ibm.com/account/reg/us-en/signup?formid=urx-43430",
    "More info URL": "https://www.ibm.com/thought-leadership/covid19/?lnk=ushpv18l1"
  },
  {
    "Name": "Monitoro",
    "Approved": "Yes",
    "Category": "Website Tools",
    "URL": "https://www.monitoro.xyz",
    "Description": "Monitor website changes and send the latest data to IFTTT, Google Sheets, Zapier, Firebase, AWS Lambda and many other services.\n\nUse our free monitors to receive notifications for grocery delivery times, update your sheets with the latest cases as well or any other website you need to watch.",
    "Discount": "Free 5 hourly monitors, 30% discount above that",
    "Does it drive you into a paid account": "No, no need for payment information and 3 months free usage.",
    "Requirement": "Free for Covid-19 projects or if you've been laid off.\nDiscount open to everyone.",
    "Favicon": "/src/assets/favicon/apple-touch-icon.png?v=ngJXw5Oder",
    "How to apply (text)": "Email support@monitoro.xyz",
    "How to apply (URL or email)": "support@monitoro.xyz",
    "More info URL": ""
  },
  {
    "Name": "Jubiwee",
    "Approved": "Yes",
    "Category": "Management Tools",
    "URL": "https://jubiwee.com",
    "Description": "Anonymous micro-surveys to follow how your team is doing and dealing with these peculiar work conditions. They will be sent automatically at the frequency of your choice, and results will be available in a real-time dashboard.",
    "Discount": "Free during the lockdown",
    "Does it drive you into a paid account": "Maybe, after COVID-19.",
    "Requirement": "",
    "Favicon": "/favicon.ico",
    "How to apply (text)": "Use the form on the page.",
    "How to apply (URL or email)": "https://jubiwee.com/en/coronavirus",
    "More info URL": ""
  },
  {
    "Name": "Hypercare",
    "Approved": "Yes",
    "Category": "Productivity Tools",
    "URL": "https://www.hypercare.com",
    "Description": "Hypercare helps clinicians coordinate clinical care by providing a HIPAA compliant solution to send clinical messages, figure out who is on-call and assign clinical tasks. We are deployed in hundreds of organizations. It's especially helpful during COVID given the complexities around patient care and the need for timely communication.",
    "Discount": "Free for 3 months",
    "Does it drive you into a paid account": "Maybe, after 3 months.",
    "Requirement": "Healthcare organizations only.",
    "Favicon": "https://uploads-ssl.webflow.com/img/webclip.png",
    "How to apply (text)": "Just signup",
    "How to apply (URL or email)": "https://www.hypercare.com/blog/hypercare-now-providing-free-unlimited-service-to-combat-covid-19/",
    "More info URL": "https://www.hypercare.com/blog/hypercare-now-providing-free-unlimited-service-to-combat-covid-19/"
  },
  {
    "Name": "Papyrs",
    "Approved": "Yes",
    "Category": "Writing Tools",
    "URL": "https://papyrs.com",
    "Description": "With Papyrs organizations can create an internal wiki/intranet site to share notes, docs, forms and work together remotely.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No need for payment information. Email us and we'll apply the 100% discount.",
    "Requirement": "Free for any health workers/humanitarian organizations working on COVID-19 relief projects",
    "Favicon": "",
    "How to apply (text)": "Email support at team@papyrs.com",
    "How to apply (URL or email)": "team@papyrs.com",
    "More info URL": ""
  },
  {
    "Name": "Zoho Remotely",
    "Approved": "Yes",
    "Category": "Remote Work",
    "URL": "https://www.zoho.com",
    "Description": "Looking for a remote work solution? Remotely is a suite of essential business applications including chat, video conferencing, office apps and more which will help you work from anywhere.",
    "Discount": "Free for 3 months",
    "Does it drive you into a paid account": "Yes, but you can cancel your subscription any time.",
    "Requirement": "",
    "Favicon": "",
    "How to apply (text)": "Just signup",
    "How to apply (URL or email)": "https://www.zoho.com/remotely/",
    "More info URL": ""
  },
  {
    "Name": "ZeroTier",
    "Approved": "Yes",
    "Category": "VPN",
    "URL": "https://my.zerotier.com",
    "Description": "All your devices on the same LAN. Peer to peer. End to end encrypted. Runs on everything.",
    "Discount": "Free",
    "Does it drive you into a paid account": "No",
    "Requirement": "Less than 100 devices.",
    "Favicon": "/favicon.ico?r=124",
    "How to apply (text)": "No application needed",
    "How to apply (URL or email)": "https://my.zerotier.com",
    "More info URL": "www.zerotier.com"
  },
  {
    "Name": "Pragli",
    "Approved": "Yes",
    "Category": "Remote Work",
    "URL": "https://pragli.com",
    "Description": "Virtual office for remote teams",
    "Discount": "Free for next 2 months",
    "Does it drive you into a paid account": "Maybe, after 2 months.",
    "Requirement": "",
    "Favicon": "",
    "How to apply (text)": "Online sign up",
    "How to apply (URL or email)": "https://pragli.com",
    "More info URL": ""
  },
  {
    "Name": "BuiltOn",
    "Approved": "Yes",
    "Category": "Website Tools",
    "URL": "https://builton.dev",
    "Description": "Manage users, products, orders, payments, and deliveries with our APIs. AI tools also. No need to build your own backend.",
    "Discount": "Unlimited API calls",
    "Does it drive you into a paid account": "No",
    "Requirement": "",
    "Favicon": "https://www.builton.dev/static/apple-touch-icon.png",
    "How to apply (text)": "Email hello@builton.dev",
    "How to apply (URL or email)": "https://builton.dev/",
    "More info URL": ""
  },
  {
    "Name": "SafetyAmp",
    "Approved": "Yes",
    "Category": "Productivity Tools",
    "URL": "https://www.safetyamp.com",
    "Description": "SafetyAmp is a configurable, all-in-one EHS platform to increase engagement, reduce risk, connect the workforce, and improve your safety, health, and quality workflows.",
    "Discount": "Free for two months",
    "Does it drive you into a paid account": "Maybe, after two months.",
    "Requirement": "SafetyAmp is making its platform available free for two months for teams needing COVID-19 auditing capabilities",
    "Favicon": "https://uploads-ssl.webflow.com/5ef3803d773621e809fa8be3/5f11fbceb58409168924702d_iphone.png",
    "How to apply (text)": "Email sales@safetyamp.com",
    "How to apply (URL or email)": "https://safetyamp.com/covid19/",
    "More info URL": ""
  },
  {
    "Name": "Blackbell",
    "Approved": "Yes",
    "Category": "eCommerce Software",
    "URL": "https://www.blackbell.com",
    "Description": "",
    "Discount": "Free for 4 months",
    "Does it drive you into a paid account": "Yes, but you can cancel your subscription anytime",
    "Requirement": "",
    "Favicon": "https://d2snvnzirxtkg3.cloudfront.net/blackbell/image/upload/c_crop,h_426,w_426,x_35,y_20/c_scale,h_150,r_max,w_150/v1519739171/permanent/jR3HYhnDQIyGi6RwVlVX_t4yg0d.png",
    "How to apply (text)": "Apply the coupon solidaritycovid19",
    "How to apply (URL or email)": "https://www.blackbell.com/en",
    "More info URL": "https://www.blackbell.com/en"
  },
  {
    "Name": "Paperspace",
    "Approved": "Yes",
    "Category": "Remote Work",
    "URL": "https://www.paperspace.com",
    "Description": "We're offering substantial free GPU resources to any team working on COVID-19-related machine learning or deep learning research.",
    "Discount": "Free GPUs",
    "Does it drive you into a paid account": "No",
    "Requirement": "",
    "Favicon": "https://assets-global.website-files.com/5db99670374d1d829291af4f/5f0c831db773eb676c5048a1_Webclip-PaperspaceMixed.png",
    "How to apply (text)": "Signup and email support@paperspace.com",
    "How to apply (URL or email)": "https://www.paperspace.com",
    "More info URL": ""
  },
  {
    "Name": "MailCertified",
    "Approved": "Waiting...",
    "Category": "Productivity Tools",
    "URL": "https://www.mailcertified.com",
    "Description": "Send certified letter with electronic return receipt via USPS for $8.29 (regular $9.29) Use share feature to community craft a letter, such as debt validation etc.",
    "Discount": "$1 off",
    "Does it drive you into a paid account": "No",
    "Requirement": "None, discounted price is open to all and displayed on the site.",
    "Favicon": "",
    "How to apply (text)": "Just go to the site and start your letter.",
    "How to apply (URL or email)": "https://www.mailcertified.com/",
    "More info URL": "https://www.mailcertified.com/site/how-does-this-work"
  },
  {
    "Name": "DevScore",
    "Approved": "Waiting...",
    "Category": "Developer Tools",
    "URL": "https://devscore.com",
    "Description": "",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "",
    "Favicon": "",
    "How to apply (text)": "Signup and email support@devscore.com",
    "How to apply (URL or email)": "support@devscore.com",
    "More info URL": ""
  },
  {
    "Name": "Zensors",
    "Approved": "Waiting...",
    "Category": "Management Tools",
    "URL": "https://www.zensors.com",
    "Description": "Camera based analytics for remote monitor your business operations",
    "Discount": "Free during lockdown",
    "Does it drive you into a paid account": "No",
    "Requirement": "",
    "Favicon": "",
    "How to apply (text)": "Just tell us you found us here",
    "How to apply (URL or email)": "https://blog.zensors.com/zensors-offers-ai-platform-to-assist-with-covid-19-and-invites-collaborators/",
    "More info URL": ""
  },
  {
    "Name": "Calendly",
    "Approved": "Waiting...",
    "Category": "Remote Work",
    "URL": "https://calendly.com",
    "Description": "Free Zoom and GoToMeeting Integrations till June",
    "Discount": "Free during lockdown",
    "Does it drive you into a paid account": "Maybe, with the upsells.",
    "Requirement": "",
    "Favicon": "https://assets-marketing-site.calendly.com/icons/icon-48x48.png?v=562a6280871383fd65846bc6297cf964",
    "How to apply (text)": "Just create a free account and you have immediate access.",
    "How to apply (URL or email)": "https://calendly.com/",
    "More info URL": "https://blog.calendly.com/meeting-integration-update/"
  },
  {
    "Name": "QueueMetrics Live",
    "Approved": "Waiting...",
    "Category": "Analytics",
    "URL": "https://www.queuemetrics-live.com",
    "Description": "QueueMetrics Live will let your monitor  your telephone traffic - real-time and with deep analysis. Even if you are not a call center, you need this to understand what your inbound telephone team is doing - especially now that everybody works remotely.",
    "Discount": "Free for 3 months for SMBs",
    "Does it drive you into a paid account": "No, you are welcome to sign up if you end up loving it, though.",
    "Requirement": "Having less than 20 agents.",
    "Favicon": "/img/graphics/favicon20150812.png",
    "How to apply (text)": "Sign up for a demo, then tell the rep you want the 3 months free plan.",
    "How to apply (URL or email)": "https://www.queuemetrics-live.com/landing/covid19.jsp",
    "More info URL": ""
  },
  {
    "Name": "Atlassian",
    "Approved": "Waiting...",
    "Category": "Developer Tools",
    "URL": "https://www.atlassian.com",
    "Description": "Atlassian's team collaboration software like Jira, Confluence and Trello help teams organize, discuss, and complete shared work.",
    "Discount": "Free for up to 10 users or build minutes (incase of Bitbucket Pipelines etc)",
    "Does it drive you into a paid account": "No",
    "Requirement": "",
    "Favicon": "https://wac-cdn.atlassian.com/assets/img/favicons/atlassian/favicon.png",
    "How to apply (text)": "Just signup through the link",
    "How to apply (URL or email)": "https://www.atlassian.com/software/free",
    "More info URL": "https://www.atlassian.com/remote"
  },
  {
    "Name": "TextIt",
    "Approved": "Waiting...",
    "Category": "Developer Tools",
    "URL": "https://textit.in",
    "Description": "TextIt allows you to build interactive messaging bots using SMS, IVR, WhatsApp, Facebook Messenger and more using an easy visual interface.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Covid19 Related project.",
    "Favicon": "/sitestatic/brands/textit/favicon.ico",
    "How to apply (text)": "Sign up for free, open a ticket to get free credits.",
    "How to apply (URL or email)": "https://textit.in/",
    "More info URL": "https://blog.textit.in/free-textit-hosting-for-coronavirus-projects"
  },
  {
    "Name": "Nodeware",
    "Approved": "Waiting...",
    "Category": "Cybersecurity",
    "URL": "https://igius.com",
    "Description": "Nodeware is a simple yet powerful vulnerability scanning tool that helps with device inventory and identifying gaps in the network. IGI is offering 90 days free with the commitment of a single annual license.",
    "Discount": "Free for 90 Days",
    "Does it drive you into a paid account": "Yes, after 3 months",
    "Requirement": "Virtual deployment only — Hyper V or VMware",
    "Favicon": "",
    "How to apply (text)": "Simply sign up on the landing page and create an account.",
    "How to apply (URL or email)": "https://info.igius.com/90-day-promo",
    "More info URL": "https://nodeware.com"
  },
  {
    "Name": "Algolia",
    "Approved": "Waiting...",
    "Category": "Website Tools",
    "URL": "https://algolia.com",
    "Description": "Create AI-powered search & discovery across websites & apps.",
    "Discount": "Free Pro Plan",
    "Does it drive you into a paid account": "No",
    "Requirement": "Covid19 Related project.",
    "Favicon": "https://www.algolia.com/icons/icon-72x72.png",
    "How to apply (text)": "Email support@algolia.com with \"COVID-19 Request\" subject",
    "How to apply (URL or email)": "https://www.algolia.com/covid-19/",
    "More info URL": ""
  },
  {
    "Name": "DocSpring",
    "Approved": "Waiting...",
    "Category": "Developer Tools",
    "URL": "https://docspring.com",
    "Description": "Build an API integration in minutes and fill out PDF forms with your data. Set up field positions and data types using our visual PDF template editor. Simply post JSON data to our API, then download a filled-out PDF in seconds.",
    "Discount": "Free for up to 10,000 PDFs / mo, then an 85% discount",
    "Does it drive you into a paid account": "No",
    "Requirement": "Covid19 related project (not-for-profit)",
    "Favicon": "/apple-touch-icon.png",
    "How to apply (text)": "Sign up for free, then email support@docspring.com",
    "How to apply (URL or email)": "https://docspring.com",
    "More info URL": ""
  },
  {
    "Name": "Tefter",
    "Approved": "Waiting...",
    "Category": "Productivity Tools",
    "URL": "https://tefter.io",
    "Description": "Social bookmarking for individuals and teams",
    "Discount": "Free for 3 months (personal), unlimited free for nonprofits",
    "Does it drive you into a paid account": "Yes, after 3 months",
    "Requirement": "",
    "Favicon": "https://d1eub78dsdxite.cloudfront.net/assets/apple-touch-icon-17060db823e010bef202c84f7efeff7bbe599d26048fc4587dbc034dce0153b5.png",
    "How to apply (text)": "Signup and email support@tefter.io or use the covid-19 code (for personal accounts only)",
    "How to apply (URL or email)": "https://tefter.io/users/sign_up?promocode=covid-19",
    "More info URL": ""
  },
  {
    "Name": "Vectorspace AI",
    "Approved": "Waiting...",
    "Category": "Analytics",
    "URL": "https://vectorspace.ai",
    "Description": "Scientific Data Engineering Pipelines for Space Biosciences",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Covid19 Related project",
    "Favicon": "/favicon.ico",
    "How to apply (text)": "Email info@vectorspace.ai or visit https://vectorspace.ai",
    "How to apply (URL or email)": "info@vectorspace.ai",
    "More info URL": "https://www.prnewswire.com/news-releases/covid-19-drug-repurposing-datasets-now-available-in-collaboration-with-vectorspace-ai-amazon--microsoft-301030507.html?tc=eml_cleartime"
  },
  {
    "Name": "Placer.ai",
    "Approved": "Waiting...",
    "Category": "Analytics",
    "URL": "https://www.placer.ai",
    "Description": "The COVID-19 Retail Impact Tracker allows you to see year-over-year changes in foot traffic for major brands in relation to coronavirus cases. Filter by brand, date, and region to see how coronavirus has been impacting visits to retail and restaurant chains nationwide.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "",
    "Favicon": "https://assets-global.website-files.com/62d4feaf5d3ddb3f0f9c5515/62d50072cb5c4044fdaa789a_placer-webclip.png",
    "How to apply (text)": "Corona correlated retail trend data is available publicly for free.",
    "How to apply (URL or email)": "https://www.placer.ai/covid-19/",
    "More info URL": "https://placer.ai"
  },
  {
    "Name": "Reclaim.ai",
    "Approved": "Waiting...",
    "Category": "Productivity Tools",
    "URL": "https://reclaim.ai",
    "Description": "Reclaim gets your calendar under control. Auto-block time for eating lunch, catching up on email, personal commitments and more -- plus get stats on where you're spending time to keep you from working endless days.",
    "Discount": "100% discount until January 2021",
    "Does it drive you into a paid account": "Maybe, after January 2021",
    "Requirement": "",
    "Favicon": "https://assets.website-files.com/5ec848ec2b50b6cfae06f6cc/60785b9d2d09ec6bfb5810c5_apple-touch-icon.png",
    "How to apply (text)": "Simply sign up for free and get started.",
    "How to apply (URL or email)": "https://reclaim.ai",
    "More info URL": "https://reclaim.ai/product"
  },
  {
    "Name": "Tettra",
    "Approved": "Waiting...",
    "Category": "Writing Tools",
    "URL": "https://tettra.com",
    "Description": "Tettra is knowledge base software that organizes scattered company information to answer your team's repetitive questions right in Slack or MS Teams.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Scaling Plan only. Non-profit working on Covid-19 related response",
    "Favicon": "https://tettra.com/wp-content/uploads/2018/11/cropped-favicon-300x300.png",
    "How to apply (text)": "Sign up and reach out over chat",
    "How to apply (URL or email)": "https://app.tettra.co/create-team",
    "More info URL": ""
  },
  {
    "Name": "CozyCal",
    "Approved": "Waiting...",
    "Category": "Remote Work",
    "URL": "https://www.cozycal.com",
    "Description": "CozyCal is a delightfully simple online scheduling app and appointment booking software. Manage bookings, collect intake forms and accept payments right on your website.",
    "Discount": "Free for 6 months",
    "Does it drive you into a paid account": "Maybe, after 6 months can cancel subscription or upgrade",
    "Requirement": "Non-profit working on Covid-19 related response",
    "Favicon": "https://uploads-ssl.webflow.com/59a7997fdd2379000163012d/59ab48202231fd0001f39587_Artboard.png",
    "How to apply (text)": "Sign up and contact support@cozycal.com for coupon code",
    "How to apply (URL or email)": "support@cozycal.com",
    "More info URL": "https://www.cozycal.com/"
  },
  {
    "Name": "ShiftX",
    "Approved": "Waiting...",
    "Category": "Productivity Tools",
    "URL": "https://shiftx.com",
    "Description": "ShiftX is a collaborative tool, empowering teams to easily visualize, understand and improve how your business operates.",
    "Discount": "Free 3 month 5 person business plan",
    "Does it drive you into a paid account": "Maybe, after 3 months or more than 5 persons",
    "Requirement": "Organizations with 50+ employees/volunteers and 30 minute on-boarding required",
    "Favicon": "//shiftx.imgix.net/images/public/favicon.pdf?fm=png&w=57&h=57",
    "How to apply (text)": "Chat bubble on https://shiftx.com or support@shiftx.com",
    "How to apply (URL or email)": "support@shiftx.com",
    "More info URL": ""
  },
  {
    "Name": "Contentful",
    "Approved": "Waiting...",
    "Category": "Website Builder",
    "URL": "https://stop-the-spread.dev",
    "Description": "A free JAMstack-based static website template and hosting in conjunction with our partners, Netlify and Gatsby",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "it is a free template on free plans by all partners",
    "Favicon": "/logo192.png",
    "How to apply (text)": "free JAMstack-based static website template and hosting in conjunction with our partners, Netlify and Gatsby",
    "How to apply (URL or email)": "https://stopthespread.dev",
    "More info URL": "https://www.contentful.com/blog/2020/03/20/stop-the-spread-covid-19/"
  },
  {
    "Name": "Routific",
    "Approved": "Waiting...",
    "Category": "Delivery management",
    "URL": "https://routific.com",
    "Description": "",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Covid19 Related project.",
    "Favicon": "https://routific.wpenginepowered.com/wp-content/uploads/2020/03/favicon.ico",
    "How to apply (text)": "Just chat with us after you sign up for a trial",
    "How to apply (URL or email)": "https://routific.com",
    "More info URL": ""
  },
  {
    "Name": "Conductor",
    "Approved": "Waiting...",
    "Category": "Productivity Tools",
    "URL": "https://www.senseilabs.com",
    "Description": "Repond and recover faster. Sensei Labs is making Conductor free for managing COVID-19 projects to help everyone get through these challenging times.",
    "Discount": "Free for 6 months",
    "Does it drive you into a paid account": "No",
    "Requirement": "COVID-19 response and recovery management",
    "Favicon": "https://www.senseilabs.com/wp-content/themes/senseilabs/favicon-16x16.png",
    "How to apply (text)": "Fill in the form and we'll get you setup",
    "How to apply (URL or email)": "https://hello.senseilabs.com/conductor-for-covid19",
    "More info URL": "https://www.senseilabs.com/conductor/conductor-for-covid-19/"
  },
  {
    "Name": "Honeybadger",
    "Approved": "Waiting...",
    "Category": "Monitoring",
    "URL": "https://www.honeybadger.io",
    "Description": "Honeybadger combines error, uptime and check-in monitoring in a simple, easy to use platform. Our mission: to tame production and make you a better, more productive developer.",
    "Discount": "Free for 6 months",
    "Does it drive you into a paid account": "Maybe, after 6 months.",
    "Requirement": "Covid19 related project (not-for-profit)",
    "Favicon": "",
    "How to apply (text)": "Sign up and email support to alert us you are part of a Covid-19 project",
    "How to apply (URL or email)": "support@honeybadger.io",
    "More info URL": "https://app.honeybadger.io/users/sign_up?plan_id=30087"
  },
  {
    "Name": "Coast App",
    "Approved": "Waiting...",
    "Category": "Productivity Tools",
    "URL": "https://coastapp.com",
    "Description": "Coast makes it easy to keep everyone on the same page by bringing team chat, tasks, and workflows into one place.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Covid-19 related",
    "Favicon": "",
    "How to apply (text)": "Sign up for free",
    "How to apply (URL or email)": "https://coastapp.com",
    "More info URL": ""
  },
  {
    "Name": "Knack",
    "Approved": "Waiting...",
    "Category": "Low-Code/No-Code",
    "URL": "https://www.knack.com",
    "Description": "Knack empowers everyday innovators to quickly build custom apps with no code required. Knack community members are already volunteering to build free apps to aid in COVID-19 relief efforts.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "COVID-19 related, non-profit project.",
    "Favicon": "",
    "How to apply (text)": "Request free application on the site.",
    "How to apply (URL or email)": "https://www.knack.com/coronavirus-response",
    "More info URL": "https://www.knack.com/coronavirus-response"
  },
  {
    "Name": "Workato",
    "Approved": "Waiting...",
    "Category": "Low-Code/No-Code",
    "URL": "http://www.workato.com",
    "Description": "Workato, a leader in Gartner MQ, is more than an iPaaS. It's an Intelligent Automation platform that can be used by both Business and IT. It supports thousands of enterprise and workflow usecases so you can automate everything.",
    "Discount": "Free for 6 months",
    "Does it drive you into a paid account": "Maybe, after 6 months.",
    "Requirement": "Covid-19 related, Some partners have offered to help with free/discounted services",
    "Favicon": "/favicon.ico",
    "How to apply (text)": "Signup for free or contact us",
    "How to apply (URL or email)": "http://www.workato.com",
    "More info URL": ""
  },
  {
    "Name": "MINTDATA",
    "Approved": "Waiting...",
    "Category": "Spreadsheets",
    "URL": "https://mintdata.com",
    "Description": "Create applications with a spreadsheet",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Free for all Covid-19 related work.",
    "Favicon": "",
    "How to apply (text)": "Email covid-19@mintdata.com for free access",
    "How to apply (URL or email)": "covid-19@mintdata.com",
    "More info URL": "https://nyt-maps.covid42.com -- an example of Covid-19 analysis on MINTDATA"
  },
  {
    "Name": "intelliHR",
    "Approved": "Waiting...",
    "Category": "People Management",
    "URL": "https://intellihr.co",
    "Description": "Keep your teams connected and feeling supported in these difficult times with our free HR Software built for the Coronavirus.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Covid-19 related",
    "Favicon": "https://intellihr.co/wp-content/uploads/2017/09/cropped-intelliHR-Icon-on-Blue-RGB-32x32.png",
    "How to apply (text)": "Fill in the form and we'll get you setup",
    "How to apply (URL or email)": "https://intellihr.co/landingPages/get-started-with-free-covid-19-essentials-platform/",
    "More info URL": "https://intellihr.co/landingPages/get-started-with-free-covid-19-essentials-platform/"
  },
  {
    "Name": "Gocious",
    "Approved": "Waiting...",
    "Category": "Project Management",
    "URL": "https://gocious.com",
    "Description": "Cloud software as a service for product planning and management. Gocious helps teams plan, analyze, and share information for hardware products.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Gocious is making its product available for free to any non-political humanitarian group that is working on COVID-19 relief efforts.",
    "Favicon": "",
    "How to apply (text)": "Sign up for a trial and then send a message to our support team for the discount.",
    "How to apply (URL or email)": "https://gocious.com/signup/",
    "More info URL": ""
  },
  {
    "Name": "Sleuth",
    "Approved": "Waiting...",
    "Category": "Developer Tools",
    "URL": "https://sleuth.io",
    "Description": "Cloud-based deployment tracking that arms remote software teams with the knowledge required to move faster.",
    "Discount": "Free for 6 months",
    "Does it drive you into a paid account": "Maybe, after 6 months.",
    "Requirement": "",
    "Favicon": "https://assets.website-files.com/5fd148f419b866c77225d463/60233349b46a67032154dbaa_Sleuth_logoOnly-256x256.png",
    "How to apply (text)": "Signup for free and we'll extend for six months.",
    "How to apply (URL or email)": "https://app.sleuth.io/account/signup/",
    "More info URL": "https://www.sleuth.io/post/now-try-sleuth-free-for-six-months"
  },
  {
    "Name": "Crowdbotics",
    "Approved": "Waiting...",
    "Category": "Low-Code/No-Code",
    "URL": "https://www.crowdbotics.com",
    "Description": "A better way to build software. Launch 3X faster and cheaper with our data-driven app development platform.",
    "Discount": "15 free development hours for health-care related apps supporting the Coronavirus crisis. Waived blueprint fees for restaurant or small business who needs to transition to online orders.",
    "Does it drive you into a paid account": "Maybe",
    "Requirement": "Health-care related apps supporting the Coronavirus crisis. Small businesses transitioning to an online business model.",
    "Favicon": "https://assets-global.website-files.com/5b5cd6b75bb9b0dce50e212f/5b691b549b93d76d9f36edeb_256.gif",
    "How to apply (text)": "Submit 'Free Quote' form and mention COVID-19 discount.",
    "How to apply (URL or email)": "https://www.crowdbotics.com/managed-app-development",
    "More info URL": "https://blog.crowdbotics.com/rapid-app-development-discounts-resources-discounts-coronavirus/"
  },
  {
    "Name": "JotForm",
    "Approved": "Waiting...",
    "Category": "Remote Work",
    "URL": "https://www.jotform.com",
    "Description": "As a thanks to healthcare pr bcactices, nonprofits, and government organizations helping respond to the Coronavirus crisis, JotForm is offering free unlimited HIPAA plans. Let us fight together!",
    "Discount": "Free for 4 months",
    "Does it drive you into a paid account": "Maybe, after 4 months.",
    "Requirement": "Eligible for first responders, healthcare workers, and nonprofits that want to help their communities.",
    "Favicon": "",
    "How to apply (text)": "Applications can be made through a JotForm",
    "How to apply (URL or email)": "https://www.jotform.com/corona-responder-program/apply/#form",
    "More info URL": "https://www.jotform.com/corona-responder-program/"
  },
  {
    "Name": "Aware",
    "Approved": "Waiting...",
    "Category": "Analytics",
    "URL": "https://www.awarehq.com",
    "Description": "",
    "Discount": "Free through May",
    "Does it drive you into a paid account": "Maybe",
    "Requirement": "Dependent upon integration platforms. Slack Enteprise Grid, Workplace from Facebook, Yammer, and Microsoft Teams.",
    "Favicon": "",
    "How to apply (text)": "Application from at the bottom of the landing page",
    "How to apply (URL or email)": "http://awarehq.com/aware-cares?ref=saasforcovid",
    "More info URL": "http://awarehq.com/aware-cares?ref=saasforcovid"
  },
  {
    "Name": "Startday",
    "Approved": "",
    "Category": "Management Tools",
    "URL": "https://startday.app",
    "Description": "Free all-in-one management platform for freelancers",
    "Discount": "Free 3 months premium",
    "Does it drive you into a paid account": "No",
    "Requirement": "",
    "Favicon": "",
    "How to apply (text)": "Automatic on Sign Up",
    "How to apply (URL or email)": "https://app.startday.dk/createaccount",
    "More info URL": "https://startday.app"
  },
  {
    "Name": "Flamelink.io",
    "Approved": "Waiting...",
    "Category": "Developer Tools",
    "URL": "https://flamelink.io",
    "Description": "Firebase is perfect for rapidly developing and scaling a global app, and Flamelink's feature rich CMS includes user permissions, media manager, webhooks and workflows that non-developer users would benefit from, allowing for instant and multi-channel, content updates. In light of the global COVID-19 pandemic, we’d like to offer our support to any team or NGO that is thinking of building a social good app in response to the Coronavirus. Whether it’s to help educate your community, offer support, keep people informed about latest developments, Flamelink can help manage the content in your application.\nContact us to get free access to an Inferno Flamelink plan to help you, help the world.",
    "Discount": "Free Enterprise plan for the duration of the COVID-19 pandemic",
    "Does it drive you into a paid account": "No",
    "Requirement": "Covid-19 related projects like apps, websites and other digital platforms built on Firebase",
    "Favicon": "",
    "How to apply (text)": "Sign-up for a 14-day free trial and contact our support team",
    "How to apply (URL or email)": "https://app.flamelink.io/register",
    "More info URL": ""
  },
  {
    "Name": "My Hours",
    "Approved": "",
    "Category": "Remote Work",
    "URL": "https://myhours.com",
    "Description": "Free Time Tracking software with a track record. Easily create shareable reports for your clients or managers, set hourly rates and generate invoices.",
    "Discount": "Unlimited team members, projects and tasks",
    "Does it drive you into a paid account": "No",
    "Requirement": "",
    "Favicon": "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd73afee589faaf4b11d25c_rsz_ms-icon-310x310.png",
    "How to apply (text)": "Automatic - Sign up via Email",
    "How to apply (URL or email)": "https://app.myhours.com/#/signup/trial/0",
    "More info URL": "https://myhours.com/support"
  },
  {
    "Name": "Bird Eats Bug",
    "Approved": "",
    "Category": "Developer Tools",
    "URL": "https://birdeatsbug.com",
    "Description": "Report and fix bugs faster. Screen recording with automatically captured techinical logs.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "",
    "Favicon": "https://global-uploads.webflow.com/61095f46b900fa59f4322389/6109643f858b230072dc55c0_bird-256.png",
    "How to apply (text)": "Automatically on sign up",
    "How to apply (URL or email)": "https://app.birdeatsbug.com",
    "More info URL": "https://birdeatsbug.com/faq"
  },
  {
    "Name": "MindMeister",
    "Approved": "",
    "Category": "Remote Work",
    "URL": "https://www.mindmeister.com",
    "Description": "We are offering a foundation on which to build your online classroom in the form of two integrated programs. When you sign up, you’ll get the business bundle, which means you’ll have access to the fully-featured versions of both MindMeister and MeisterTask.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "COVID-19 related for educational institutions and teachers",
    "Favicon": "https://www.mindmeister.com/mm_favicon.ico",
    "How to apply (text)": "Submit a request via a form",
    "How to apply (URL or email)": "https://docs.google.com/forms/d/e/1FAIpQLSeDB4wwXfF50axq-f--NRQUhwgjUgweMPKlSRQI9ul9rJ8gVA/viewform",
    "More info URL": "https://www.meisterlabs.com/meister-for-educators/"
  },
  {
    "Name": "Dashly",
    "Approved": "",
    "Category": "Website Tools",
    "URL": "https://dashly.io",
    "Description": "Grow sales without growing traffic and provide excellent customer support",
    "Discount": "0-50%",
    "Does it drive you into a paid account": "Maybe, depends on your plan and project",
    "Requirement": "30% or 50% for the new users of Dashly:\nfree for teams and people that fight COVID-19 and its consequences",
    "Favicon": "/icons/icon-48x48.png?v=a630d0ff5346677908ea14af614d6d40",
    "How to apply (text)": "Send a message in live chat, the agents will help",
    "How to apply (URL or email)": "https://www.dashly.io/blog/crisis-management-with-dashly/",
    "More info URL": "https://www.dashly.io/blog/crisis-management-with-dashly/"
  },
  {
    "Name": "MeisterTask",
    "Approved": "",
    "Category": "Project Management",
    "URL": "https://www.meistertask.com",
    "Description": "We are offering a foundation on which to build your online classroom in the form of two integrated programs. When you sign up, you’ll get the business bundle, which means you’ll have access to the fully-featured versions of both MindMeister and MeisterTask.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "COVID-19 related for educational institutions and teachers",
    "Favicon": "",
    "How to apply (text)": "Submit a request via a form",
    "How to apply (URL or email)": "https://docs.google.com/forms/d/e/1FAIpQLSeDB4wwXfF50axq-f--NRQUhwgjUgweMPKlSRQI9ul9rJ8gVA/viewform",
    "More info URL": "https://www.meisterlabs.com/meister-for-educators/"
  },
  {
    "Name": "kidpofy",
    "Approved": "",
    "Category": "Website Tools",
    "URL": "https://kidpofy.com",
    "Description": "Continuously, find a way to keep all the memories of your children, right? Would you like to keep how your children write in their first years?",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "",
    "Favicon": "",
    "How to apply (text)": "Automatically on sign up",
    "How to apply (URL or email)": "https://kidpofy.com",
    "More info URL": ""
  },
  {
    "Name": "LetterWell",
    "Approved": "",
    "Category": "Ads",
    "URL": "https://letterwell.co",
    "Description": "",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Business/brand has an email newsletter",
    "Favicon": "",
    "How to apply (text)": "Automatically on sign up",
    "How to apply (URL or email)": "https://letterwell.co",
    "More info URL": "https://letterwell.co/about"
  },
  {
    "Name": "PukkaTeam",
    "Approved": "",
    "Category": "Remote Work",
    "URL": "https://pukkateam.com",
    "Description": "PukkaTeam is an always-on, online workplace for your remote team to work together throughout the day, improve communication, team awareness and feel more connected, no matter where they are. Find Out More!",
    "Discount": "60 day trial",
    "Does it drive you into a paid account": "Yes, after 60 days",
    "Requirement": "50% discount on all packages",
    "Favicon": "",
    "How to apply (text)": "Automatically on sign up for trial extension.\n50% discount code is LOVEREMOTE2020",
    "How to apply (URL or email)": "https://pukkateam.com/",
    "More info URL": "https://pukkateam.com/how-does-pukkateam-work"
  },
  {
    "Name": "Karen",
    "Approved": "",
    "Category": "Productivity Tools",
    "URL": "https://karenapp.io",
    "Description": "Karen helps medical care givers schedule meetings and appointments with patients.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "",
    "Favicon": "/static/karen/favicons/apple-icon-57x57.png",
    "How to apply (text)": "Use code SixMo50 for discount",
    "How to apply (URL or email)": "https://karenapp.io",
    "More info URL": "https://karenapp.io"
  },
  {
    "Name": "Typeform",
    "Approved": "",
    "Category": "Data collection",
    "URL": "http://www.typeform.com",
    "Description": "We're offering 3 months free of Typeform Premium for anyone working on COVID-19 related projects that are strictly not-for-profit.",
    "Discount": "Free for 3 months",
    "Does it drive you into a paid account": "Maybe, after 3 months.",
    "Requirement": "Nonprofit Covid-19 response project",
    "Favicon": "/apple-touch-icon.png",
    "How to apply (text)": "Submit a request form",
    "How to apply (URL or email)": "https://try.typeform.com/covid-19/",
    "More info URL": "https://try.typeform.com/covid-19/"
  },
  {
    "Name": "Sweet Jam Sites",
    "Approved": "",
    "Category": "Website Builder",
    "URL": "https://sweetjamsites.com",
    "Description": "I'll build a COVID-19-related website for you in a day, for FREE. Yes totally free. Anything that would help people be more informed, supported, safer or supplied.",
    "Discount": "Free",
    "Does it drive you into a paid account": "No, as long as it's for COVID19-related social good causes",
    "Requirement": "",
    "Favicon": "",
    "How to apply (text)": "Fill out contact form",
    "How to apply (URL or email)": "https://sweetjamsites.com/covid-19",
    "More info URL": "https://sweetjamsites.com/covid-19"
  },
  {
    "Name": "Legaler",
    "Approved": "",
    "Category": "Remote Work",
    "URL": "https://legaler.com",
    "Description": "Legaler offers free tools to help you schedule, host and archive online meetings securely in your browser with end-to-end encryption for video calls and messaging. Meet Smarter. Meet Legaler.",
    "Discount": "Free for 12 months",
    "Does it drive you into a paid account": "Maybe, after 12 months.",
    "Requirement": "Solo Lawyers, Law firms, Law Students, Legal support",
    "Favicon": "",
    "How to apply (text)": "To activate the code simply follow these steps after you signup",
    "How to apply (URL or email)": "https://legaler.com/covid-19/",
    "More info URL": ""
  },
  {
    "Name": "Placid",
    "Approved": "",
    "Category": "Website Tools",
    "URL": "https://placid.app",
    "Description": "Automatically generate social share images",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Free Pro plan for Covid-19 projects. Discounts available for affected businesses",
    "Favicon": "/apple-icon-57x57.png",
    "How to apply (text)": "Contact us via live chat",
    "How to apply (URL or email)": "https://placid.app/",
    "More info URL": ""
  },
  {
    "Name": "Upflow",
    "Approved": "",
    "Category": "Finance",
    "URL": "https://upflow.io",
    "Description": "Stop wasting time and automate customer payments reminders. With Upflow, businesses quickly collect unpaid invoices and reduce overdue payments by 50%.",
    "Discount": "50%",
    "Does it drive you into a paid account": "Yes",
    "Requirement": "",
    "Favicon": "/favicon/apple-touch-icon.png",
    "How to apply (text)": "Contact via chat",
    "How to apply (URL or email)": "https://upflow.io",
    "More info URL": ""
  },
  {
    "Name": "NoCodeAPI",
    "Approved": "",
    "Category": "Developer Tools",
    "URL": "https://nocodeapi.com",
    "Description": "The easiest way to built your Google Sheet, Airtable, Google Analytics, Twitter, Telegram, Open Graph API, MailChimp without any backend.",
    "Discount": "50%",
    "Does it drive you into a paid account": "Maybe",
    "Requirement": "",
    "Favicon": "https://nocodeapi.com/wp-content/uploads/2022/06/icon-logo-300x300.png",
    "How to apply (text)": "There is already 50% discount on yearly subscription https://nocodeapi.com/pricing",
    "How to apply (URL or email)": "https://nocodeapi.com/pricing",
    "More info URL": "https://nocodeapi.com/what-is-nocodeapi"
  },
  {
    "Name": "James",
    "Approved": "",
    "Category": "Productivity Tools",
    "URL": "https://tasks.getjames.app",
    "Description": "Automated task management system that plans your day for you without any further work nescessary",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "No payment method or anything",
    "Favicon": "logo.png",
    "How to apply (text)": "Just sign up",
    "How to apply (URL or email)": "https://getjames.app",
    "More info URL": ""
  },
  {
    "Name": "CustomFit.ai",
    "Approved": "",
    "Category": "Lead generation",
    "URL": "https://customfit.ai",
    "Description": "CustomFit.ai is a no-code website personalization tool. It increases website conversions by engaging each micro-segment of your audience with customized website content.",
    "Discount": "15%",
    "Does it drive you into a paid account": "Yes",
    "Requirement": "",
    "Favicon": "https://uploads-ssl.webflow.com/60a39c4de6d69fa0d4b339c0/61712973ac78cfdff430c087_Webp.net-resizeimage.png",
    "How to apply (text)": "Fill out demo request form",
    "How to apply (URL or email)": "https://customfit.ai/demo",
    "More info URL": "https://customfit.ai/playbook"
  },
  {
    "Name": "Deer Designer",
    "Approved": "",
    "Category": "Web/Graphic Design",
    "URL": "https://deerdesigner.com",
    "Description": "Get a personal design team to do all your design work. Best for SaaS, agencies and entrepreneurs.",
    "Discount": "10% (First month)",
    "Does it drive you into a paid account": "Maybe, it's a discount so their earn money.",
    "Requirement": "",
    "Favicon": "https://deerdesigner.com/wp-content/uploads/deerdesigner-logo.png",
    "How to apply (text)": "Use coupon COVID19 on the checkout",
    "How to apply (URL or email)": "https://deerdesigner.com",
    "More info URL": "https://deerdesigner.com"
  },
  {
    "Name": "Wingman",
    "Approved": "",
    "Category": "Sales Tools",
    "URL": "https://www.trywingman.com",
    "Description": "Wingman allows remote sales teams to stay in sync by transcribing and analyzing every sales call. In real-time it also suggests battlecards and cues to help sales people have better conversations to close more deals",
    "Discount": "Free for 3 months",
    "Does it drive you into a paid account": "Yes",
    "Requirement": "",
    "Favicon": "https://assets-global.website-files.com/5c6bb8ab3620cfc71f70b984/62b2eff25f7b49213e6609ad_Favicon.svg",
    "How to apply (text)": "Just sign up",
    "How to apply (URL or email)": "https://www.trywingman.com/going-remote",
    "More info URL": ""
  },
  {
    "Name": "kiwiHR",
    "Approved": "",
    "Category": "Remote Work",
    "URL": "https://kiwihr.com",
    "Description": "Jumpstart your company's remote work transition using HR software. Track staff time, leave, and find all data 24/7 with ready-to-use HR software. Free for 3 months.",
    "Discount": "Free for 3 months",
    "Does it drive you into a paid account": "Yes, but you can cancel before starting paid subscription.",
    "Requirement": "",
    "Favicon": "data:image/png;base64,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",
    "How to apply (text)": "Simply fill in form on website, then use coupon strongertogether when subscribing",
    "How to apply (URL or email)": "https://kiwihr.com/en/stronger-together?utm_source=saasforcovid&utm_medium=referral&utm_campaign=en-stronger-together",
    "More info URL": "https://kiwihr.com/en/stronger-together?utm_source=saasforcovid&utm_medium=referral&utm_campaign=en-stronger-together"
  },
  {
    "Name": "Luxlock",
    "Approved": "",
    "Category": "Remote Work",
    "URL": "https://www.luxlock.com",
    "Description": "Digitize your retail associates so they can #WFH or anywhere. Omni-channel clienteling product messaging software for fancy brands.",
    "Discount": "500 free user licenses for everyone, Free SaaS for 3 months w/Shopify and BigCommerce",
    "Does it drive you into a paid account": "Yes, but we can base it on a quarterly ROI analysis",
    "Requirement": "",
    "Favicon": "https://uploads-ssl.webflow.com/60d493fbf3aee2512e738a3f/610775303a25dd30da959efb_Luxlock%20Icon%20250x250.png",
    "How to apply (text)": "Simply request a demo",
    "How to apply (URL or email)": "https://luxlock.com/demo/",
    "More info URL": "https://www.producthunt.com/posts/luxlock"
  },
  {
    "Name": "FoxBound",
    "Approved": "",
    "Category": "Sales Tools",
    "URL": "https://foxbound.io/",
    "Description": "Build targeted lists of prospects and deliver personalized sales campaigns with an all-in-one platform",
    "Discount": "Free for life; 30% off all paid plans",
    "Does it drive you into a paid account": "Maybe, only if you hit limits of the free Starter Plan",
    "Requirement": "New customers",
    "Favicon": "",
    "How to apply (text)": "Use the code, REBOUND30, in the Billing area",
    "How to apply (URL or email)": "https://app.foxbound.io/users/sign_up",
    "More info URL": "https://foxbound.io/project-rebound-remote-sales/"
  },
  {
    "Name": "Jiminny",
    "Approved": "",
    "Category": "Sales Tools",
    "URL": "https://www.jiminny.com/",
    "Description": "Jiminny is the platform for all your customer conversations. We record, transcribe, and analyze your calls & meetings in real-time so you can capture every data point important to your business and have the insights to help your team win together",
    "Discount": "Free for 3 months",
    "Does it drive you into a paid account": "Maybe, after 3 months and only for new customers.",
    "Requirement": "New customers",
    "Favicon": "https://www.jiminny.com/hubfs/favicon.ico",
    "How to apply (text)": "Request demo on the webite",
    "How to apply (URL or email)": "https://www.jiminny.com/request-a-demo",
    "More info URL": "https://www.jiminny.com/product/coaching-made-easy"
  },
  {
    "Name": "Air",
    "Approved": "",
    "Category": "Remote Work",
    "URL": "https://air.inc",
    "Description": "Air is a workspace for your team's images and videos. Organize, manage, and collaborate with the visual content that drives your business. Where distributed teams do their best work.",
    "Discount": "Free for 1st month (or as long as needed)",
    "Does it drive you into a paid account": "Yes",
    "Requirement": "No requirement (all customers receive a free month)",
    "Favicon": "/apple-touch-icon.png",
    "How to apply (text)": "Sign up on the website and use the code WFH",
    "How to apply (URL or email)": "https://air.inc",
    "More info URL": ""
  },
  {
    "Name": "KernelCare",
    "Approved": "",
    "Category": "Cybersecurity",
    "URL": "https://www.kernelcare.com/",
    "Description": "KernelCare is live vulnerability patching for Linux servers and devices. It provides rapid, automatic kernel security patching for Linux servers while they are operational, thus increasing security for those environments.",
    "Discount": "Free for the rest of 2020",
    "Does it drive you into a paid account": "No, no need for payment information and free for the rest of 2020",
    "Requirement": "Healthcare organisations",
    "Favicon": "",
    "How to apply (text)": "Sign up and we will jump in to help with deployment on all your servers",
    "How to apply (URL or email)": "https://lp.kernelcare.com/kernelcare-for-free-for-healthcare",
    "More info URL": "https://www.kernelcare.com/product/"
  },
  {
    "Name": "Noisli",
    "Approved": "",
    "Category": "Productivity Tools",
    "URL": "https://www.noisli.com",
    "Description": "Noisli provides background sounds that help to mask distracting noises and create a personal sound environment for calm and focus.",
    "Discount": "Free 2 months of the Business plan",
    "Does it drive you into a paid account": "Yes, but you can cancel at any time and before any payment takes place",
    "Requirement": "Free for Businesses impacted by COVID-1",
    "Favicon": "https://about.noisli.com/assets/icons/icon-196x196.png",
    "How to apply (text)": "Fill in the request form",
    "How to apply (URL or email)": "https://support.noisli.com/coronavirus-response",
    "More info URL": "https://support.noisli.com/coronavirus-response"
  },
  {
    "Name": "Databand",
    "Approved": "",
    "Category": "Monitoring",
    "URL": "https://databand.ai/",
    "Description": "Databand provides monitoring and observability for data pipelines. Instantly discover data quality issues and the root cause of pipeline failures.",
    "Discount": "Free for 3 months",
    "Does it drive you into a paid account": "100% free for COVID-related data projects",
    "Requirement": "100% free for COVID-related data projects",
    "Favicon": "https://databand.ai/wp-content/uploads/2020/11/cropped-Icon-circle-dark-background-180x180.png",
    "How to apply (text)": "Fill out demo request form",
    "How to apply (URL or email)": "https://databand.ai/request-demo/",
    "More info URL": ""
  },
  {
    "Name": "Status Hero",
    "Approved": "",
    "Category": "Management Tools",
    "URL": "https://statushero.com",
    "Description": "Status Hero is a lightweight application for tracking daily goals, activity logs from your tools, and status check-ins from your team, all in one place. Remote teams love it. Sync up your team, kill stand-up meetings, inform stakeholders, and quickly cut through all of the management noise.",
    "Discount": "Free for 6 months",
    "Does it drive you into a paid account": "Yes",
    "Requirement": "COVID-19 related, non-profit organizations",
    "Favicon": "/assets/icons/favicon-196x196.png",
    "How to apply (text)": "Create a free trial and message support from within your account",
    "How to apply (URL or email)": "https://statushero.com/signup",
    "More info URL": "https://statushero.com"
  },
  {
    "Name": "Pleo",
    "Approved": "",
    "Category": "Finance",
    "URL": "https://www.pleo.io",
    "Description": "Pleo offers smart company credit & virtual cards that simplify any company spending.",
    "Discount": "Free until July",
    "Does it drive you into a paid account": "No",
    "Requirement": "None",
    "Favicon": "/helios/static/favicon-0c1f3a43589bbaf89459a4491ba89dbe.ico",
    "How to apply (text)": "Fill out demo request form",
    "How to apply (URL or email)": "https://www.pleo.io",
    "More info URL": ""
  },
  {
    "Name": "Writing Analytics",
    "Approved": "",
    "Category": "Writing Tools",
    "URL": "https://www.writinganalytics.co",
    "Description": "Writing Analytics is a writing tracker that helps authors and bloggers build a sustainable writing routine.",
    "Discount": "Free until 1 June",
    "Does it drive you into a paid account": "No, it cancels automatically at the end of the free period",
    "Requirement": "None",
    "Favicon": "/assets/icons/apple-touch-icon.png",
    "How to apply (text)": "Just sign up",
    "How to apply (URL or email)": "https://app.writinganalytics.co/signup/covid-19",
    "More info URL": "https://www.writinganalytics.co/posts/covid-19/"
  },
  {
    "Name": "College Life Work",
    "Approved": "",
    "Category": "Recruitment",
    "URL": "https://collegelife.co/work/",
    "Description": "College Life Work is a career platform for top international students & graduates.",
    "Discount": "Free for 3 months",
    "Does it drive you into a paid account": "Maybe, after 3 months",
    "Requirement": "None",
    "Favicon": "https://work.collegelife.co/assets/favicon/apple-touch-icon-75b889d538ab4cb0faf6f458e28b4488ed20b94c85b79254c890a875f02d0882.png",
    "How to apply (text)": "Sign up and send email with subject \"COVID\" to info@collegelife.co",
    "How to apply (URL or email)": "info@collegelife.co",
    "More info URL": "https://collegelife.co/nl/employers/"
  },
  {
    "Name": "CloudForecast",
    "Approved": "",
    "Category": "Developer Tools",
    "URL": "https://www.cloudforecast.io",
    "Description": "CloudForecast helps companies monitor and eliminate wasted AWS cost without",
    "Discount": "Free for 2 months",
    "Does it drive you into a paid account": "No, they have an option where no Credit Card is required to start a free-trial.",
    "Requirement": "None",
    "Favicon": "images/webclip.png",
    "How to apply (text)": "Email tony@cloudforecast.io with subject COVID",
    "How to apply (URL or email)": "https://app.cloudforecast.io/users/sign_up",
    "More info URL": "www.cloudforecast.io"
  },
  {
    "Name": "PandaDoc Free eSignatures",
    "Approved": "",
    "Category": "Sales Tools",
    "URL": "https://www.pandadoc.com/",
    "Description": "PandaDoc is offering a new free eSign plan to securely send an unlimited number of documents for signatures and collect payments.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No need for payment information and free forever",
    "Requirement": "None",
    "Favicon": "//assets.cdnpandadoc.com/app/packages/www-next/img/fav/icon-180-509eb5f708.png",
    "How to apply (text)": "Sign up on the website from this page",
    "How to apply (URL or email)": "https://signup.pandadoc.com/?plan=rec_plans_v4_free",
    "More info URL": "https://www.pandadoc.com/free-electronic-signature-software/"
  },
  {
    "Name": "Qualified",
    "Approved": "",
    "Category": "Assessments",
    "URL": "https://www.qualified.io",
    "Description": "Qualified is the most effective platform for assessing software developers. Use it for education, certification and recruiting.",
    "Discount": "Free for 1st year",
    "Does it drive you into a paid account": "No, first year free and no credit card required",
    "Requirement": "New K-12 customers",
    "Favicon": "/favicon-f99f13ec.ico",
    "How to apply (text)": "Complete request trial form",
    "How to apply (URL or email)": "https://www.qualified.io/signup",
    "More info URL": "https://www.qualified.io/blog/posts/qualified-and-codewars-are-free-for-k-12-teachers-and-students"
  },
  {
    "Name": "Designmodo",
    "Approved": "",
    "Category": "Developer Tools",
    "URL": "https://designmodo.com/freemonth/",
    "Description": "Timesaving tools for designers and developers. Website and Email Builders.",
    "Discount": "Free for 1st month",
    "Does it drive you into a paid account": "Yes, but you can cancel the subscription",
    "Requirement": "None",
    "Favicon": "i/favicon.png",
    "How to apply (text)": "Use coupon code FREEMONTH during checkout.",
    "How to apply (URL or email)": "https://designmodo.com/freemonth/",
    "More info URL": "https://designmodo.com/freemonth/"
  },
  {
    "Name": "Adext AI",
    "Approved": "",
    "Category": "Ads",
    "URL": "https://adext.ai",
    "Description": "Fully Automated Advertising Technology powered AI designed to improve and scale your campaigns performance while decreasing your cost.",
    "Discount": "Buy 3 months, Get 3 months for Free",
    "Does it drive you into a paid account": "Yes",
    "Requirement": "None",
    "Favicon": "https://bmaas-web-platform-assets.s3.amazonaws.com/public/assets/favicons/favicon-32.png",
    "How to apply (text)": "Sign up and use code COVID19",
    "How to apply (URL or email)": "https://amaas.adext.ai/register",
    "More info URL": "WWW.ADEXT.AI"
  },
  {
    "Name": "Cast",
    "Approved": "",
    "Category": "Reporting",
    "URL": "https://cast.app",
    "Description": "Generate reports you can watch, listen, read, on any device and any time for Stripe, Salesforce, APIs, and more.",
    "Discount": "45 days free",
    "Does it drive you into a paid account": "No",
    "Requirement": "New Customers. Free for Stripe. Paid for SalesForce and API",
    "Favicon": "",
    "How to apply (text)": "Request access and mention SaaSforCovid.com",
    "How to apply (URL or email)": "https://cast.app/#access-form",
    "More info URL": "https://cast.app"
  },
  {
    "Name": "Codetally",
    "Approved": "",
    "Category": "Developer Tools",
    "URL": "https://www.codetally.com",
    "Description": "Codetally helps you determine the costs of developing projects over time. You control the configuration with files in your Github repo. Calculations occur in real-time with every commit.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Sign in with your Github account.",
    "How to apply (URL or email)": "https://github.com/login/oauth/authorize?client_id=Iv1.28ff997c607a6195&scope=user%20public_repo",
    "More info URL": "https://www.codetally.com/#/help"
  },
  {
    "Name": "Lark",
    "Approved": "",
    "Category": "Remote Work",
    "URL": "https://www.larksuite.com",
    "Description": "Lark is the next-generation collaboration suite that enables teams to do their best work together. The suite primarily consists of Lark Messenger, Lark Docs, Lark Calendar, Lark Video Conferencing, as well as Lark Workplace which integrates third-party applications. All functionalities are deeply integrated into a single app, which is available on Mac, PC, iOS, and Android. Visit www.larksuite.com to start using Lark for free.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "None",
    "Favicon": "https://framerusercontent.com/modules/1aOL9kBKzB5IToQlqP7A/A6QrxsKLJTNEytvsSO1Q/assets/hcGreyrfhraQY3XbjoUhBYejORo.png",
    "How to apply (text)": "Just sign up",
    "How to apply (URL or email)": "https://www.larksuite.com",
    "More info URL": "www.larksuite.com"
  },
  {
    "Name": "Joonko",
    "Approved": "",
    "Category": "Recruitment",
    "URL": "https://joonko.co/",
    "Description": "Joonko is an automated diversity recruitment solutions helping expose open positions at forward-thinking companies to qualified, diverse candidates. During COVID-19, Joonko is offering a free tier of our service so companies can continue to reach their hiring goals.",
    "Discount": "Free tier of recruitment softwre",
    "Does it drive you into a paid account": "Maybe, if there's further interest in additional features or tiers",
    "Requirement": "Must have an Applicant Tracking System",
    "Favicon": "/favicon.png",
    "How to apply (text)": "Just sign up",
    "How to apply (URL or email)": "https://register.joonko.com",
    "More info URL": "https://joonko.co/how-it-works"
  },
  {
    "Name": "KgBase",
    "Approved": "",
    "Category": "Low-Code/No-Code",
    "URL": "https://kgbase.com/",
    "Description": "KgBase is a no-code tool for building Knowledge graphs",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "COVID-19 related",
    "Favicon": "/static/images/favicon/apple-icon-57x57.png",
    "How to apply (text)": "",
    "How to apply (URL or email)": "demo@kgbase.com",
    "More info URL": "https://kgbase.com/pages/learn"
  },
  {
    "Name": "Keyhub",
    "Approved": "",
    "Category": "Cybersecurity",
    "URL": "https://remme.io",
    "Description": "Keyhub is a cloud-based platform to automatically discover, organize, and track all SSL/TLS certificates across the enterprise.",
    "Discount": "100% for the Standard plan",
    "Does it drive you into a paid account": "No",
    "Requirement": "Only Standard plan and for all companies fighting COVID-19",
    "Favicon": "https://assets.website-files.com/5933fd4773e44b4d95d597e8/5c76a05d245b51182dc5c1e3_remme-favicon-purple.png",
    "How to apply (text)": "Fill out Contact Us form",
    "How to apply (URL or email)": "https://remme.io/contact-us",
    "More info URL": "https://remme.io/keyhub"
  },
  {
    "Name": "Hexadecimal",
    "Approved": "",
    "Category": "Monitoring",
    "URL": "https://tryhexadecimal.com",
    "Description": "Hexadecimal is a no-nonsense website monitoring and status page service. Unlike with other monitoring tools, Hexadecimal has minimum false positives, rich & actionable notifications, knowledgable & friendly support from the founder, and no tracking.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No, you don't have to enter any payment information.",
    "Requirement": "COVID-19 related projects only.",
    "Favicon": "/assets/images/apple-touch-icon.png",
    "How to apply (text)": "Sign up and let me know",
    "How to apply (URL or email)": "https://dashboard.tryhexadecimal.com",
    "More info URL": "https://tryhexadecimal.com"
  },
  {
    "Name": "dstack.ai",
    "Approved": "",
    "Category": "Developer Tools",
    "URL": "https://dstack.ai",
    "Description": "In-cloud hosting and Python/R APIs to publish datasets, data visualizations, and interactive dashboards.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "None",
    "Favicon": "images/dstack_fav_32.ico",
    "How to apply (text)": "Just sign up",
    "How to apply (URL or email)": "https://dstack.ai",
    "More info URL": "https://dstack.ai"
  },
  {
    "Name": "Jobtrackable",
    "Approved": "",
    "Category": "Recruitment",
    "URL": "https://www.jobtrackable.com/",
    "Description": "Jobtrackable is built for job seekers to organize their job search by tracking every job opportunity. The platform allows them to save applications from every job board, set tasks and follow up applications.",
    "Discount": "6 months free",
    "Does it drive you into a paid account": "Maybe, after 6 months",
    "Requirement": "First time users",
    "Favicon": "",
    "How to apply (text)": "Sign up with code CORONA and email at himanshu@jobtrackable.com to get Standard plan (6 months) free",
    "How to apply (URL or email)": "https://www.jobtrackable.com/",
    "More info URL": "https://www.jobtrackable.com/plans-pricing"
  },
  {
    "Name": "BigRadar",
    "Approved": "",
    "Category": "Marketing/ LiveChat",
    "URL": "https://www.bigradar.io",
    "Description": "Live chat software with email marketing",
    "Discount": "3 months free",
    "Does it drive you into a paid account": "Maybe, after 3 months",
    "Requirement": "First time users",
    "Favicon": "https://bigradar.io/content/uploads/2022/09/256.png",
    "How to apply (text)": "Drop an email to team@bigradar.io with subject: Corona",
    "How to apply (URL or email)": "https://www.bigradar.io",
    "More info URL": ""
  },
  {
    "Name": "Coda",
    "Approved": "",
    "Category": "Remote Work",
    "URL": "https://coda.io/welcome",
    "Description": "Coda is a new document that brings words, data, and teams together. For those who exceed limits of the free tier and want access to our team/pro plan, Coda is offering discounts to offset costs for (1.) direct response/contribution to COVID-19 relief efforts and/or (2.) financial hardships due to COVID-19",
    "Discount": "100% discount for 3 months",
    "Does it drive you into a paid account": "Yes. Email support@coda.io for full details.",
    "Requirement": "Available to new and existing users for COVID-19 related purposes (see description)",
    "Favicon": "https://cdn.coda.io/icons/png/color/coda-apple-120.png",
    "How to apply (text)": "Email support@coda.io",
    "How to apply (URL or email)": "support@coda.io",
    "More info URL": ""
  },
  {
    "Name": "ContractAwesome",
    "Approved": "",
    "Category": "Contract Management",
    "URL": "https://contractawesome.com",
    "Description": "Best-in-class, end-to-end contract management solutions for businesses of all sizes. Create, sign and store all your legal documents in one, safe place.",
    "Discount": "6 months free ($114 value)",
    "Does it drive you into a paid account": "Maybe, after 6 months",
    "Requirement": "None. Valid for all users.",
    "Favicon": "",
    "How to apply (text)": "",
    "How to apply (URL or email)": "https://contractawesome.com",
    "More info URL": "https://contractawesome.com"
  },
  {
    "Name": "Fluxo",
    "Approved": "",
    "Category": "Finance",
    "URL": "https://www.fluxo.ai",
    "Description": "Financial modeling and forecasting software for startups & SMBs. Integrate your workflow, automate forecasts, and customize shareable reports.",
    "Discount": "100%",
    "Does it drive you into a paid account": "Only after you hit free account limits.",
    "Requirement": "None.",
    "Favicon": "",
    "How to apply (text)": "",
    "How to apply (URL or email)": "https://www.fluxo.ai",
    "More info URL": "https://www.fluxo.ai/pricing"
  },
  {
    "Name": "InvoiceQuick",
    "Approved": "",
    "Category": "Finance",
    "URL": "https://invoicequick.com",
    "Description": "Professional Invoices Made Easy. Who small business, freelancers and startups trust to look professional, invoice on-the-go & get paid faster. The best part, it’s free!",
    "Discount": "3 months free",
    "Does it drive you into a paid account": "No, you don't have to enter any payment information.",
    "Requirement": "None.",
    "Favicon": "front-page/images/webclip.png",
    "How to apply (text)": "",
    "How to apply (URL or email)": "https://app.invoicequick.com/auth/register",
    "More info URL": "https://invoicequick.com/help-free-users/"
  },
  {
    "Name": "Unicorn Nest",
    "Approved": "",
    "Category": "Finance",
    "URL": "http://unicorn-nest.com/",
    "Description": "Get the list of the most relevant VCs and their decision makers to raise the next round (seed and the following)",
    "Discount": "$0.01 for earch search",
    "Does it drive you into a paid account": "Yes, but only $0.01",
    "Requirement": "None.",
    "Favicon": "https://unicorn-nest.com/wp-content/uploads/2021/04/apple-icon-120x120-1.png?x40197",
    "How to apply (text)": "",
    "How to apply (URL or email)": "http://unicorn-nest.com/",
    "More info URL": ""
  },
  {
    "Name": "Curb-To-Car",
    "Approved": "",
    "Category": "Delivery management",
    "URL": "https://curbtocar.com",
    "Description": "Simple curb-side check-in for any business",
    "Discount": "$1/mo per location",
    "Does it drive you into a paid account": "Yes, but only $1/month",
    "Requirement": "none",
    "Favicon": "",
    "How to apply (text)": "",
    "How to apply (URL or email)": "https://curbtocar.com",
    "More info URL": "https://curbtocar.com"
  },
  {
    "Name": "Rulecontent.com",
    "Approved": "",
    "Category": "Sales Tools",
    "URL": "https://rulecontent.com",
    "Description": "Get a platform with content that drives growth for your business",
    "Discount": "40% Discount",
    "Does it drive you into a paid account": "Yes, but you get a lot of value for a fair price.",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "",
    "How to apply (URL or email)": "https://rulecontent.com/?cov=1",
    "More info URL": "https://rulecontent.com/?cov=1"
  },
  {
    "Name": "Aardvark",
    "Approved": "",
    "Category": "Sales Tools",
    "URL": "https://vark.io",
    "Description": "Get rid of \"no shows\" with automatic text reminders and close more deals. Seamless integration with Hubspot.",
    "Discount": "100% discount for 3 months",
    "Does it drive you into a paid account": "Yes, it's for first time users only",
    "Requirement": "First time users",
    "Favicon": "https://i.ibb.co/ft0kCck/aardvark-logo.png",
    "How to apply (text)": "",
    "How to apply (URL or email)": "https://vark.io",
    "More info URL": "http://vark.io/aardvark-response-covid-19"
  },
  {
    "Name": "Krisp",
    "Approved": "",
    "Category": "Remote Work",
    "URL": "https://krisp.ai",
    "Description": "Krisp introduces a free tier. All users get 120min/week of free noise cancellation.. All students, teachers, hospital and government workers, worldwide, get unlimited Krisp for free.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "All students, teachers, hospital and government workers, worldwide, get unlimited Krisp for free.",
    "Favicon": "https://krisp.ai/wp-content/uploads/2020/02/cropped-KLogo-1-180x180.png",
    "How to apply (text)": "",
    "How to apply (URL or email)": "https://krisp.ai/",
    "More info URL": "https://krisp.ai/blog/covid19-response/"
  },
  {
    "Name": "Livestorm",
    "Approved": "",
    "Category": "Remote Work",
    "URL": "https://livestorm.co",
    "Description": "Video conferencing and webinar software, directly from the browser.",
    "Discount": "Free meetings during COVID, Webinars 20% Discount",
    "Does it drive you into a paid account": "No",
    "Requirement": "None",
    "Favicon": "/apple-touch-icon.png",
    "How to apply (text)": "",
    "How to apply (URL or email)": "https://livestorm.co/blog/livestorm-and-covid-19/",
    "More info URL": "https://livestorm.co/"
  },
  {
    "Name": "PayRequest",
    "Approved": "",
    "Category": "Finance",
    "URL": "https://payrequest.io",
    "Description": "Create your own donation page and share it everywhere.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "COVID-19 related projec",
    "Favicon": "",
    "How to apply (text)": "",
    "How to apply (URL or email)": "https://payrequest.io/donation-pages",
    "More info URL": "https://payrequest.io/donation-pages"
  },
  {
    "Name": "Investor Hunt",
    "Approved": "",
    "Category": "Finance",
    "URL": "http://investorhunt.co",
    "Description": "Investor Hunt is a database of 40k+ investors to raise your seed round",
    "Discount": "50%",
    "Does it drive you into a paid account": "",
    "Requirement": "",
    "Favicon": "https://investorhunt.co/favicon.ico",
    "How to apply (text)": "Use this code: Stay-Safe",
    "How to apply (URL or email)": "https://investorhunt.co/pricing",
    "More info URL": ""
  },
  {
    "Name": "Richie Lending",
    "Approved": "",
    "Category": "Sales Tools",
    "URL": "https://saas.richielending.com",
    "Description": "Shopify for business loan brokers. We help anyone start, run and scale a loan brokerage. We provide a website, CRM, and do all the negotiatios with lenders and do the paperwork.",
    "Discount": "50%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Be a sales company; be a professional broker; be a fintech lender",
    "Favicon": "",
    "How to apply (text)": "Use this code: RichieLendingCares",
    "How to apply (URL or email)": "https://saas.richielending.com",
    "More info URL": "https://youtu.be/M-2ChKyWrQ8"
  },
  {
    "Name": "newclick.io",
    "Approved": "",
    "Category": "CMS",
    "URL": "http://newclick.io",
    "Description": "Create, design and schedule shopify banners. Run more ecommerce discounts and get more sales with announcement banners and templates.",
    "Discount": "50%",
    "Does it drive you into a paid account": "Yes, 14 day free trial",
    "Requirement": "None. Works on any website",
    "Favicon": "",
    "How to apply (text)": "",
    "How to apply (URL or email)": "http://newclick.io/",
    "More info URL": "http://newclick.io/"
  },
  {
    "Name": "Music for Makers",
    "Approved": "",
    "Category": "Video & Music",
    "URL": "https://musicformakers.com",
    "Description": "Get Royalty-Free Music for Your Podcasts, Videos, and More",
    "Discount": "25%",
    "Does it drive you into a paid account": "Maybe, but it's one-time payment",
    "Requirement": "",
    "Favicon": "https://musicformakers.com/wp-content/uploads/cropped-logo-icon-180x180.png",
    "How to apply (text)": "License music",
    "How to apply (URL or email)": "https://musicformakers.com/",
    "More info URL": "https://musicformakers.com/"
  },
  {
    "Name": "Continually",
    "Approved": "",
    "Category": "Marketing/ LiveChat",
    "URL": "https://continual.ly",
    "Description": "No-code chatbot builder + live chat for your website. Get free Business subscription for 6 months.",
    "Discount": "100%",
    "Does it drive you into a paid account": "Maybe, but after 6 months you'll move to a lower volume forever free plan",
    "Requirement": "None",
    "Favicon": "/images/favicons/favicon.ico",
    "How to apply (text)": "Reply to the welcome email + mention COVID-19",
    "How to apply (URL or email)": "https://continual.ly/",
    "More info URL": "https://continual.ly/"
  },
  {
    "Name": "Kimp.io",
    "Approved": "",
    "Category": "Web/Graphic Design",
    "URL": "https://kimp.io",
    "Description": "Unlimited Graphic Design, unlimited revisions, unlimited brands. 7-Days free trial. Flat Monthly Fee. Save time and money with a dedicated design team. Kimp is for startups, SMEs, marketers, creative agencies, entrepreneurs.",
    "Discount": "50%",
    "Does it drive you into a paid account": "Yes, after 7 days free trial",
    "Requirement": "First time users",
    "Favicon": "//q5g9j9b9.stackpathcdn.com/wp-content/themes/kimpan/assets/images/favicon.png",
    "How to apply (text)": "Just sign up, discount applied already.",
    "How to apply (URL or email)": "https://kimp.io/?saasforcovid=discount",
    "More info URL": "https://www.kimp.io/"
  },
  {
    "Name": "Creately",
    "Approved": "",
    "Category": "Diagramming and Collaboration tool",
    "URL": "https://creately.com",
    "Description": "Creately is an easy to use diagram and flowchart software built for team collaboration with Google Drive and Slack integration. Supports over 40+ diagram types and has 1000’s of professionally drawn templates.",
    "Discount": "50% on Team Plan",
    "Does it drive you into a paid account": "Free version comprises of 5 diagrams",
    "Requirement": "None",
    "Favicon": "/static/assets/common/icons/favicons-next/apple-touch-icon.png",
    "How to apply (text)": "Use the discount code at the time of purchase",
    "How to apply (URL or email)": "https://creately.com/remote-working-guide/",
    "More info URL": "https://creately.com/"
  },
  {
    "Name": "Circuit",
    "Approved": "",
    "Category": "Delivery management",
    "URL": "https://getcircuit.com",
    "Description": "Delivery route planner for businesses who started handling their own deliveries. Add all your deliveries and Circuit will create the most efficient routes for all your drivers to use with the mobile app. You can use the webapp to follow their progress during the day. Includes proof of delivery and automatic updates for recipients.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Free for charities, heavy discounts for restaurants etc",
    "Favicon": "/img/favicon.png",
    "How to apply (text)": "Sign up and then contact them via the chat inside the app",
    "How to apply (URL or email)": "https://getcircuit.com/blog/covid-19-free-for-charities-90-off-for-restaurants/",
    "More info URL": "https://getcircuit.com/team/"
  },
  {
    "Name": "Automate.io",
    "Approved": "",
    "Category": "Low-Code/No-Code",
    "URL": "https://automate.io",
    "Description": "Automate.io is an easy-to-use workflow automation tool that lets you connect the web apps you use every day. You can pass data through them and automate repetitive tasks without having to code or relying on developers.",
    "Discount": "45 days FREE for existing paid customers",
    "Does it drive you into a paid account": "Maybe",
    "Requirement": "You have to be an existing paid user of Automate.io. If you downgrade to the free plan, you can avail the 45-day FREE offer.",
    "Favicon": "/assets/img/favicon.png",
    "How to apply (text)": "In the 'Downgrade to Free Plan' page in your account, select the reason for cancellation as Coronavirus/Covid-19 and click 'Avail 45-day Free Offer'",
    "How to apply (URL or email)": "help@automate.io",
    "More info URL": ""
  },
  {
    "Name": "Hellonext.co",
    "Approved": "",
    "Category": "Productivity Tools",
    "URL": "https://hellonext.co",
    "Description": "Hellonext.co is a simple customer feedback management & feature upvote tool. Comes with custom domains, mobile app, and so much more. Avail 50% discount on all plans during COVID-19 situation. Ping us on chat.",
    "Discount": "50% off on all plans",
    "Does it drive you into a paid account": "No",
    "Requirement": "None",
    "Favicon": "/favicon/apple-icon-57x57.png",
    "How to apply (text)": "Just ping us on chat on the website.",
    "How to apply (URL or email)": "https://hellonext.co",
    "More info URL": "https://hellonext.co"
  },
  {
    "Name": "SEOwl",
    "Approved": "",
    "Category": "Marketing/ LiveChat",
    "URL": "https://www.seowl.co",
    "Description": "Next-generation rank tracker, backlink monitor & SEO reporting tool.",
    "Discount": "50% off on all plans",
    "Does it drive you into a paid account": "Yes",
    "Requirement": "None",
    "Favicon": "/images/favicon.ico",
    "How to apply (text)": "Email support@seowl.co",
    "How to apply (URL or email)": "support@seowl.co",
    "More info URL": "https://www.seowl.co"
  },
  {
    "Name": "Charts Factory",
    "Approved": "",
    "Category": "Productivity Tools",
    "URL": "https://chartsfactory.com",
    "Description": "Create simple charts super fast!",
    "Discount": "$6 off on Starter Pack Yearly",
    "Does it drive you into a paid account": "Yes",
    "Requirement": "None",
    "Favicon": "https://chartsfactory.com/shortcut-01.png",
    "How to apply (text)": "Use coupon code thanksyearly",
    "How to apply (URL or email)": "https://chartsfactory.com/#pricing",
    "More info URL": "https://chartsfactory.com"
  },
  {
    "Name": "SpotOn",
    "Approved": "",
    "Category": "Marketing Automation",
    "URL": "https://spotonwifi.com",
    "Description": "Marketing SaaS to grow customer loyalty, automate a better review score and increast return visits. Connect, capture and keep more customers with our all-in-one marketing platform",
    "Discount": "Free until 1 June",
    "Does it drive you into a paid account": "No, no payment details required.",
    "Requirement": "Businesses heavily impacted by COVID-19",
    "Favicon": "",
    "How to apply (text)": "Use coupon: FIGHTCOVID",
    "How to apply (URL or email)": "info@spotonwifi.com",
    "More info URL": "https://spotonwifi.com"
  },
  {
    "Name": "Prisync",
    "Approved": "",
    "Category": "eCommerce Software",
    "URL": "https://prisync.com",
    "Description": "Price tracking and dynamic pricing SaaS for any type or size of E-commerce business.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No, no payment details required. No contracts. No commitments.",
    "Requirement": "Covid-19 Impacted E-commerce Businesses. New customers.",
    "Favicon": "https://prisync.com/wp-content/uploads/2020/07/cropped-prisync-icon-black-180x180.png",
    "How to apply (text)": "Sign up from the link provided here.",
    "How to apply (URL or email)": "https://prisync.com/register",
    "More info URL": ""
  },
  {
    "Name": "YAROOMS",
    "Approved": "",
    "Category": "Management Tools",
    "URL": "https://www.yarooms.com",
    "Description": "Room and resource management software.",
    "Discount": "100%",
    "Does it drive you into a paid account": "Maybe, after 6 months",
    "Requirement": "You are a hospital/ medical facility",
    "Favicon": "",
    "How to apply (text)": "Sign up and request a free account",
    "How to apply (URL or email)": "https://www.yarooms.com/blog/yarooms-offers-free-space-management-for-hospitals/",
    "More info URL": "https://www.yarooms.com/blog/yarooms-offers-free-space-management-for-hospitals/"
  },
  {
    "Name": "Reportei",
    "Approved": "",
    "Category": "Analytics",
    "URL": "https://reportei.com/en",
    "Description": "Social Media Reports: Reports for Instagram, Facebook, Ads, YouTube, LinkedIn, Analytics, Google Ads and others. Generate professional reports in just 3 seconds and stop wasting time with manual tasks",
    "Discount": "30% for 3 months",
    "Does it drive you into a paid account": "Maybe, but you get a clear discount so you know upfront.",
    "Requirement": "None",
    "Favicon": "https://reportei.com/wp-content/uploads/2021/06/favicon-32x32-1.png",
    "How to apply (text)": "Use coupon: SAASFORCOVID",
    "How to apply (URL or email)": "https://reportei.com/en/",
    "More info URL": ""
  },
  {
    "Name": "Intention",
    "Approved": "",
    "Category": "Hosting",
    "URL": "https://www.intention.nl",
    "Description": "Green hosting with clear fees and very good support. Especially the support! Pick this hosting provider if you want to support smaller companies.",
    "Discount": "25%",
    "Does it drive you into a paid account": "Maybe, but you get a clear discount so you know upfront.",
    "Requirement": "COVID-19 projects.",
    "Favicon": "",
    "How to apply (text)": "Contact support (can be in Dutch or English)",
    "How to apply (URL or email)": "https://www.intention.nl/direct-jouw-vraag-stellen",
    "More info URL": ""
  },
  {
    "Name": "WideBot",
    "Approved": "",
    "Category": "Marketing Automation",
    "URL": "https://widebot.net",
    "Description": "The First Arabic-Focused Bot Builder Platform. We help businesses build smart chatbots that speak the MENA language without coding in few minutes.",
    "Discount": "100%",
    "Does it drive you into a paid account": "Yes",
    "Requirement": "None",
    "Favicon": "https://i0.wp.com/widebot.net/wp-content/uploads/2020/10/cropped-logo-1.png?fit=180%2C180&ssl=1",
    "How to apply (text)": "When you upgrade to pro add promo code \"BeSafe",
    "How to apply (URL or email)": "https://widebot.net",
    "More info URL": ""
  },
  {
    "Name": "AppScreens",
    "Approved": "",
    "Category": "App Store Optimisation",
    "URL": "https://appscreens.com",
    "Description": "Design high-quality, pixel perfect screenshots for your Apple & Android apps. The all in one solution to save time, money and boost your app store impact by 35%!\nBusiness owner? Marketer? Designer? Full stack developer? AppScreens is designed for you.",
    "Discount": "50%",
    "Does it drive you into a paid account": "Maybe, but you get a clear discount so you know upfront.",
    "Requirement": "First time users",
    "Favicon": "https://appscreens.com/assets/apple-touch-icon.png",
    "How to apply (text)": "Use coupon: COVID19 on the pricing & subscription page",
    "How to apply (URL or email)": "https://appscreens.com",
    "More info URL": "https://appscreens.com/pricing"
  },
  {
    "Name": "SuperPay",
    "Approved": "",
    "Category": "Finance",
    "URL": "https://superpayit.com",
    "Description": "Easily collect one time and recurring payments.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Must be a non-profit helping to in the Covid-19 effort",
    "Favicon": "",
    "How to apply (text)": "Just register and contact support via the live chat to get access to the dicount",
    "How to apply (URL or email)": "https://superpayit.com/",
    "More info URL": ""
  },
  {
    "Name": "Bundy",
    "Approved": "",
    "Category": "People Management",
    "URL": "https://bundy.io",
    "Description": "Bundy provides you with all the features your team needs to work from home in minutes.",
    "Discount": "100%",
    "Does it drive you into a paid account": "Maybe, after 10 employees",
    "Requirement": "None",
    "Favicon": "./apple-touch-icon.png",
    "How to apply (text)": "Signup online",
    "How to apply (URL or email)": "https://bundy.io",
    "More info URL": "https://bundy.io"
  },
  {
    "Name": "Freelo",
    "Approved": "",
    "Category": "Project Management",
    "URL": "https://freelo.app/",
    "Description": "Simple project management + internal communication tool for remote teams worldwide.",
    "Discount": "100%",
    "Does it drive you into a paid account": "Maybe, after 6 months.",
    "Requirement": "COVID-19 projects, businesses impacted by COVID-19",
    "Favicon": "/img/favicons/apple-touch-icon.png",
    "How to apply (text)": "Signup online, use promo code ZACHRANNYKRUH",
    "How to apply (URL or email)": "https://app.freelo.cz/premium/checkout/choose-plan",
    "More info URL": "https://freelo.app/"
  },
  {
    "Name": "Hostitor",
    "Approved": "",
    "Category": "Hosting",
    "URL": "https://hostitor.com",
    "Description": "Host Unlimited Websites with Unlimited Storage and Bandwidth. Sign up for free, no payment required.",
    "Discount": "6 months",
    "Does it drive you into a paid account": "Maybe, after 6 months, then $15/year",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Just Sign up from Homepage or other pages",
    "How to apply (URL or email)": "https://www.hostitor.com/sign-up",
    "More info URL": "https://www.hostitor.com/"
  },
  {
    "Name": "Ideanote",
    "Approved": "",
    "Category": "Remote Work",
    "URL": "https://ideanote.io",
    "Description": "All-in-one idea management for remote teams. One central hub to collect, manage and act on ideas.",
    "Discount": "60%",
    "Does it drive you into a paid account": "Maybe, after September",
    "Requirement": "COVID-19 projects, businesses impacted by COVID-19",
    "Favicon": "https://assets-global.website-files.com/5ffa0a049299970b9577fbcf/605a07992aa352264879012b_logomark-256x256-webclip.png",
    "How to apply (text)": "Just sign up or open chat on pricing page.",
    "How to apply (URL or email)": "https://ideanote.it",
    "More info URL": "https://ideanote.io"
  },
  {
    "Name": "Sponseasy",
    "Approved": "",
    "Category": "Website Builder",
    "URL": "https://sponseasy.com",
    "Description": "A simple proposal builder to better pitch, sell and close sponsorship for anything (your online event too).",
    "Discount": "100%",
    "Does it drive you into a paid account": "Maybe, after July",
    "Requirement": "Covid-19 related projects (website, apps, iniatives looking for sponsors, online events to support artists...)",
    "Favicon": "https://uploads-ssl.webflow.com/img/webclip.png",
    "How to apply (text)": "Sign Up and contact us using the chat.",
    "How to apply (URL or email)": "contact@sponseasy.com",
    "More info URL": "https://sponseasy.com/#covidhelp"
  },
  {
    "Name": "Miro",
    "Approved": "",
    "Category": "Diagramming and Collaboration tool",
    "URL": "https://miro.com",
    "Description": "A collaborative online whiteboard for any kind of team to visually collaborate synchronously or asynchronously from anywhere.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Free education plan for all k-12 and higher ed students and educators, 30% off team plan for nonprofits and 100% off for nonprofits working on COVID-19 initiatives.",
    "Favicon": "",
    "How to apply (text)": "Free forever: sign up. Education and NPO plans: apply for eligibility.",
    "How to apply (URL or email)": "https://miro.com/",
    "More info URL": ""
  },
  {
    "Name": "ubersuggest",
    "Approved": "",
    "Category": "Content Marketing",
    "URL": "https://neilpatel.com/ubersuggest/",
    "Description": "Ubersuggest helps you generate keyword ideas for your content marketing strategy and production.",
    "Discount": "100% for 7 days",
    "Does it drive you into a paid account": "Yes, after 7 days",
    "Requirement": "",
    "Favicon": "",
    "How to apply (text)": "just use the application",
    "How to apply (URL or email)": "https://neilpatel.com/ubersuggest/",
    "More info URL": ""
  },
  {
    "Name": "User.com",
    "Approved": "",
    "Category": "Marketing/ LiveChat",
    "URL": "https://user.com/en",
    "Description": "An omnichannel Live Chat, Email Marketing, Marketing Automation platform with Push Notifications and SMS messages. plus more!",
    "Discount": "100% for 6 months",
    "Does it drive you into a paid account": "Maybe, after 6 months.",
    "Requirement": "Governmental, educational or healthcare institution responding to COVID-19",
    "Favicon": "https://assets.website-files.com/637cb013128547f2276f560d/637ce13631ca163fb45fb482_apple.png",
    "How to apply (text)": "please mention #ngo-user in chat to receive a free 6-month Business plan.",
    "How to apply (URL or email)": "https://app.user.com/accounts/register/",
    "More info URL": "https://user.com/en/blog/covid-19-support-for-gov-agencies-ngos/"
  },
  {
    "Name": "Call to Shop",
    "Approved": "",
    "Category": "eCommerce Software",
    "URL": "http://callto.shop/",
    "Description": "Human connection in retail. Customers videocall during opening hours and make a purchase using Stripe. Your own app for Android and iOs.",
    "Discount": "100% for 3 months",
    "Does it drive you into a paid account": "Maybe, after 3 months.",
    "Requirement": "None.",
    "Favicon": "",
    "How to apply (text)": "Just send us a message.",
    "How to apply (URL or email)": "https://www.callto.shop",
    "More info URL": ""
  },
  {
    "Name": "LiveAgent",
    "Approved": "",
    "Category": "Help Desk Software",
    "URL": "https://www.liveagent.com/",
    "Description": "Multi-channel help desk system. Combine your regular emails, live chats, call center and social networks into single tool. Work remotely from your home and support your customers via voice. Provide excellent customer service while keeping your employees safe during the coronavirus pandemic.",
    "Discount": "250$ credit",
    "Does it drive you into a paid account": "No",
    "Requirement": "None.",
    "Favicon": "https://www.liveagent.com/app/themes/liveagent/assets/images/favicon/apple-touch-icon.png",
    "How to apply (text)": "Send us a message to: andy@liveagent.com with subject \"SaaS4Covid",
    "How to apply (URL or email)": "https://www.liveagent.com/trial/",
    "More info URL": "https://www.liveagent.com/customer-service-during-coronavirus/"
  },
  {
    "Name": "Wobaka",
    "Approved": "",
    "Category": "CRM",
    "URL": "https://wobaka.com",
    "Description": "Wobaka helps you get more done in less time by focusing on the essentials. Not website builders or blog engines. Just a great CRM.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Affected businesses and COVID-19 projects",
    "Favicon": "",
    "How to apply (text)": "Sign up and send us a message",
    "How to apply (URL or email)": "fredrik@wobaka.com",
    "More info URL": "https://wobaka.com"
  },
  {
    "Name": "Fieldfusion",
    "Approved": "",
    "Category": "Management Tools",
    "URL": "https://fieldfusion.io/",
    "Description": "Fieldfusion is cloud-based Field Service Management (FSM) software — a web application for office staff, and a mobile application for field engineers. It provides a seamless, real-time connection between your office staff, field teams and customers so they're kept up-to-date at all times, maximising operational efficiency, empowering staff and delighting customers.",
    "Discount": "100% for 3 months",
    "Does it drive you into a paid account": "Maybe, user has the option to continue after 3-months",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Sign-up using the link on the homepage.",
    "How to apply (URL or email)": "https://fieldfusion.io/fieldfusion-core-free-for-3-months-coronavirus/",
    "More info URL": ""
  },
  {
    "Name": "SurveySparrow",
    "Approved": "",
    "Category": "Data collection",
    "URL": "http://surveysparrow.com/",
    "Description": "SurveySparrow is an end to end Conversational Experience Management Platform that helps get 40% better response rate.",
    "Discount": "30% forever",
    "Does it drive you into a paid account": "Maybe, but it's a clear discount.",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Sign-up and ask for the saasforcovid discount",
    "How to apply (URL or email)": "http://surveysparrow.com/",
    "More info URL": "http://surveysparrow.com/pricing"
  },
  {
    "Name": "Post Affiliate Pro",
    "Approved": "",
    "Category": "Affiliate Marketing",
    "URL": "https://www.postaffiliatepro.com/",
    "Description": "Start your affiliate program with affiliate marketing software - Post Affiliate Pro in minutes with 14-day free trial. Grow your business and increase your sales.",
    "Discount": "250$ credit",
    "Does it drive you into a paid account": "Maybe, but it's a clear discount.",
    "Requirement": "None.",
    "Favicon": "https://www.postaffiliatepro.com/app/themes/postaffiliatepro/assets/images/favicon/apple-touch-icon.png",
    "How to apply (text)": "Send us a message to: andy@postaffiliatepro.com with subject \"SaaS4Covid",
    "How to apply (URL or email)": "https://www.postaffiliatepro.com/trial/",
    "More info URL": "https://www.postaffiliatepro.com/affiliate-marketing-software/"
  },
  {
    "Name": "Sparkup",
    "Approved": "",
    "Category": "Remote Work",
    "URL": "https://sparkup.app/",
    "Description": "Make your meetings and events more interactive with a powerful Q&A and polling platform.\nGive a voice to your audience - Collect real-time insights - Energize your participants\nYou can use it with zoom, slack, hangout, skype..etc",
    "Discount": "100% for 3 months",
    "Does it drive you into a paid account": "No",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Just sign up",
    "How to apply (URL or email)": "https://get.sparkup.app/remote-work/",
    "More info URL": "https://sparkup.app/fr"
  },
  {
    "Name": "Learner Mobile",
    "Approved": "",
    "Category": "Learning Management System",
    "URL": "https://learnermobile.com",
    "Description": "A next generation LMS that gets the right content and training\nat the right time to the right person, so they can\nperform their best as a virtual worker.",
    "Discount": "100% for 3 months",
    "Does it drive you into a paid account": "Maybe, after 3 months.",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Send message to: info@learnermobile.com",
    "How to apply (URL or email)": "info@learnermobile.com",
    "More info URL": "https://learnermobile.com"
  },
  {
    "Name": "Weglot",
    "Approved": "",
    "Category": "Website Tools",
    "URL": "https://weglot.com/",
    "Description": "Weglot is a SaaS startup that allows companies of all sizes to make their websites multilingual in a few minutes and without the need for technical skills.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "To any website related to providing information about COVID-19",
    "Favicon": "",
    "How to apply (text)": "Send an email to coronavirus@weglot.com after sign up to Weglot",
    "How to apply (URL or email)": "coronavirus@weglot.com",
    "More info URL": ""
  },
  {
    "Name": "BaseDash",
    "Approved": "",
    "Category": "Developer Tools",
    "URL": "https://basedash.io",
    "Description": "Modern database client for startups to view and edit data collaboratively.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No, automatically cancels after 3 months",
    "Requirement": "BaseDash Pro is free for 3 months for any startups affected by COVID-19",
    "Favicon": "",
    "How to apply (text)": "Sign up for free, then email max@basedash.io for 3 months free",
    "How to apply (URL or email)": "https://basedash.io/create-account",
    "More info URL": "https://basedash.io"
  },
  {
    "Name": "Growth-X",
    "Approved": "",
    "Category": "Lead generation",
    "URL": "http://growth-x.com",
    "Description": "Generate highly engaged and laser-targeted leads.",
    "Discount": "100% for 2 months",
    "Does it drive you into a paid account": "Maybe, after 2 months",
    "Requirement": "COVID-19 projects (non-profit only).  In addition - if you are startup struggling due to COVID-19 we will do our best efforts to help!",
    "Favicon": "",
    "How to apply (text)": "sign up for a free demo account, then email help@growth-x.com",
    "How to apply (URL or email)": "https://web.growthx-app.com/signup",
    "More info URL": ""
  },
  {
    "Name": "Zendesk",
    "Approved": "",
    "Category": "Help Desk Software",
    "URL": "https://www.zendesk.com",
    "Description": "We know things are a little weird right now, and that business isn’t business as usual. That’s why we put together a six-month complimentary Remote Support Bundle to help your team keep up with changing customer demand due to COVID-19.",
    "Discount": "Add-Ons free for 90 days",
    "Does it drive you into a paid account": "You need a paid account to begin, these add-ons are free for the 90 day period.",
    "Requirement": "The Remote Support Bundle is accessible with a subscription to the Pro or Enterprise versions of our Support or Support Suite plans",
    "Favicon": "",
    "How to apply (text)": "Fill in the form from the link",
    "How to apply (URL or email)": "https://www.zendesk.com/campaign/remote-support-bundle/",
    "More info URL": "https://www.zendesk.com/campaign/remote-support-bundle/"
  },
  {
    "Name": "Easyship",
    "Approved": "",
    "Category": "eCommerce Software",
    "URL": "https://www.easyship.com/",
    "Description": "Extended 90 Day Free Trial\nMigrating offline orders online or trying to keep up with a surge in online orders? We're offering a 90-day free trial of our Plus package for all new customers who sign up before June 30, 2020. If you're currently on a 30-day trial, we'll extend this to 90 days to give you a bit more breathing room.\n\nThis offer's merchant's live chat support, and branded tracking features, to offer increased transparency to their customers.",
    "Discount": "100% for 3 months",
    "Does it drive you into a paid account": "Yes, but we have a free plan for merchants under 100 shipments per month. Live chat and branded tracking only available on free plans, otherwise tracking and email offered in free plan.",
    "Requirement": "",
    "Favicon": "",
    "How to apply (text)": "Use code: MNMKH",
    "How to apply (URL or email)": "https://try.easyship.com/small-business-relief/",
    "More info URL": ""
  },
  {
    "Name": "Luminati",
    "Approved": "",
    "Category": "Data collection",
    "URL": "https://luminati.io/",
    "Description": "Luminati is a leading Data Collection Automation platform, offering high-performance and fast data collection products and services",
    "Discount": "$250 discount for the 1st month, including all residential packages",
    "Does it drive you into a paid account": "Maybe, it depends on the customer",
    "Requirement": "New customers",
    "Favicon": "https://luminati-holanetworksltd.netdna-ssl.com/favicon.ico?md5=15406-80ba0b60",
    "How to apply (text)": "Just sign up",
    "How to apply (URL or email)": "https://luminati.io/",
    "More info URL": "https://luminati.io/"
  },
  {
    "Name": "Expertrec",
    "Approved": "",
    "Category": "Website Tools",
    "URL": "https://www.expertrec.com/covid-19-discount/",
    "Description": "Expertrec is an internal website search engine",
    "Discount": "50% for all medical institutions and communities fighting coronavirus",
    "Does it drive you into a paid account": "Yes",
    "Requirement": "New and old customers",
    "Favicon": "",
    "How to apply (text)": "Sign up and send an email to support@expertrec.com with subject line \"COVID 19\" and your website URL",
    "How to apply (URL or email)": "https://www.expertrec.com/covid-19-discount/",
    "More info URL": "https://www.expertrec.com/covid-19-discount/"
  },
  {
    "Name": "Enhancv",
    "Approved": "",
    "Category": "Recruitment",
    "URL": "www.enhancv.com",
    "Description": "Enhancv is one of the most used resume builders on the web",
    "Discount": "100% free for 1 month",
    "Does it drive you into a paid account": "Maybe, but no credit card asked, to recurring fees",
    "Requirement": "New and old customers",
    "Favicon": "",
    "How to apply (text)": "Just add your email",
    "How to apply (URL or email)": "https://enhancv.com/covid-19/",
    "More info URL": ""
  },
  {
    "Name": "Apify",
    "Approved": "",
    "Category": "Data collection",
    "URL": "https://apify.com",
    "Description": "Apify is the one-stop shop for all your web scraping, data extraction, and web RPA needs. Turn any website into an API.",
    "Discount": "100% (up to Business plan)",
    "Does it drive you into a paid account": "No",
    "Requirement": "Free of charge to anyone working on a COVID-19 project",
    "Favicon": "",
    "How to apply (text)": "Use the chatbot on the page",
    "How to apply (URL or email)": "https://apify.com/covid-19",
    "More info URL": ""
  },
  {
    "Name": "Doko Maps",
    "Approved": "",
    "Category": "Cartography",
    "URL": "https://dokomaps.com",
    "Description": "Doko Maps is a tool to create, organize and share places on a map.\nOur free trial is now for 90 days to help cities, communities, anyone map operating businesses during the lockdown.",
    "Discount": "100% for 3 months",
    "Does it drive you into a paid account": "Maybe, after 3 months",
    "Requirement": "Free of charge to anyone working on a COVID-19 project",
    "Favicon": "",
    "How to apply (text)": "Just sign up",
    "How to apply (URL or email)": "contact@dokomaps.com",
    "More info URL": "https://dokomaps.com/"
  },
  {
    "Name": "Kognity",
    "Approved": "",
    "Category": "Other (add in tab \"Categories\")",
    "URL": "kognity.com",
    "Description": "Kognity offers intelligent textbooks and online learning platforms for the IB, IGCSE, GCSE curriculums.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Schools need to be in countries that are in lockdown and doing distance learning.",
    "Favicon": "",
    "How to apply (text)": "Sign up via the form on the kognity website.",
    "How to apply (URL or email)": "https://kognity.com/support-coronavirus/",
    "More info URL": "https://kognity.com/support-coronavirus/"
  },
  {
    "Name": "LambdaTest",
    "Approved": "",
    "Category": "Website Tools",
    "URL": "www.lambdatest.com",
    "Description": "LambdaTest is cross browser testing platform which will helps users to perform remote testing of website or web-app on 2000+ browsers & OS",
    "Discount": "30% off",
    "Does it drive you into a paid account": "Maybe, but has a clear discount",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Use the chatbot on the page",
    "How to apply (URL or email)": "https://www.lambdatest.com/non-profit",
    "More info URL": ""
  },
  {
    "Name": "Jamespot",
    "Approved": "",
    "Category": "Remote Work",
    "URL": "https://www.en.jamespot.com/",
    "Description": "All-in-one collaborative platform with all the required applications to efficiently boost your teams on a daily basis.",
    "Discount": "100% for 2 months",
    "Does it drive you into a paid account": "Maybe, after 2 months",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Sign up and send an email to info@jamespot.com",
    "How to apply (URL or email)": "https://launch.jamespot.com/",
    "More info URL": ""
  },
  {
    "Name": "CallTrackingMetrics",
    "Approved": "",
    "Category": "Remote Work",
    "URL": "https://www.calltrackingmetrics.com/",
    "Description": "Seamlessly power your workforce and monitor agent performance from anywhere. Track and manage calls, texts, forms, and chats in a single platform.",
    "Discount": "100% on any plan until June 1, 2020",
    "Does it drive you into a paid account": "Maybe, but you can cancel anytime",
    "Requirement": "New customers",
    "Favicon": "",
    "How to apply (text)": "Just sign up and the discount will be applied",
    "How to apply (URL or email)": "https://www.calltrackingmetrics.com/plans-pricing/",
    "More info URL": "https://www.calltrackingmetrics.com/covid-19/"
  },
  {
    "Name": "Hypersay",
    "Approved": "",
    "Category": "Live Presentations",
    "URL": "https://hypersay.com",
    "Description": "Remote presentations: Slide sharing, Live quizzes, Live subtitles, Video streaming.",
    "Discount": "100% for 1 month",
    "Does it drive you into a paid account": "Yes, after 1 month",
    "Requirement": "New customers",
    "Favicon": "",
    "How to apply (text)": "Hit the chat button and ask for the free month trial.",
    "How to apply (URL or email)": "https://hypersay.com",
    "More info URL": ""
  },
  {
    "Name": "acronym",
    "Approved": "",
    "Category": "Cybersecurity",
    "URL": "https://acronymx.com",
    "Description": "Created for startups + SMBs, acronym helps teams build their first privacy + security program. Teams affected by the crisis are encouraged to reach out for free services.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Pay it forward",
    "Favicon": "https://acronymx.com/static/images/favicon.310dc5e17c76.ico",
    "How to apply (text)": "Sign up + email hello@acronymx.com - free for 12 months plus consulting services + workshops for qualifying teams",
    "How to apply (URL or email)": "https://acronymx.com",
    "More info URL": ""
  },
  {
    "Name": "Evidence",
    "Approved": "",
    "Category": "Website Tools",
    "URL": "https://evidence.io",
    "Description": "Convert more visitors using the power of social proof. Help guide site visitors by showing real-time actions and purchases from other site visitors.",
    "Discount": "100% for 2 months",
    "Does it drive you into a paid account": "Yes, but user can cancel in-app at anytime",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Use the promo code saas4covid when creating account",
    "How to apply (URL or email)": "https://app.evidence.io/register",
    "More info URL": "https://evidence.io"
  },
  {
    "Name": "Returns Center",
    "Approved": "",
    "Category": "Delivery management",
    "URL": "https://www.returnscenter.com/",
    "Description": "A must-have returns management tool that guarantees a happy post-purchase experience. It helps you build brand loyalty and turn returns into repurchases.",
    "Discount": "100% (Less than 3 returns per month）",
    "Does it drive you into a paid account": "No",
    "Requirement": "Free forever plan (Less than 3 returns per month）",
    "Favicon": "",
    "How to apply (text)": "Sign up + choose free plan",
    "How to apply (URL or email)": "https://blog.aftership.com/forever-free-at-returns-center/",
    "More info URL": ""
  },
  {
    "Name": "KIRIM.EMAIL",
    "Approved": "",
    "Category": "Marketing Automation",
    "URL": "https://en.kirim.email/",
    "Description": "The only email marketing services with built-in automated email verifications. Stop paying for broken emails and built relationships with real people on your email list.",
    "Discount": "50% off on all plan",
    "Does it drive you into a paid account": "No",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Just sign up and use coupon code: WFH",
    "How to apply (URL or email)": "https://en.kirim.email/",
    "More info URL": "https://en.kirim.email/"
  },
  {
    "Name": "Letsignit",
    "Approved": "",
    "Category": "Email signature manager",
    "URL": "http://www.letsignit.io",
    "Description": "Letsignit is the simplest, centralized email signature manager that allows you to create, attribute and operate harmonized signatures for your entire company. Go further and add targeted campaigns to transform your email into a powerful communication tool. 100% compatible with Office 365, Exchange and G Suite.",
    "Discount": "Free emergency kit",
    "Does it drive you into a paid account": "No",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Fill out the form",
    "How to apply (URL or email)": "https://www.letsignit.io/emergency-kit-contact-form/",
    "More info URL": ""
  },
  {
    "Name": "2DAYSMOOD Remote Experience Monitor",
    "Approved": "",
    "Category": "Management Tools",
    "URL": "https://2daysmood.com",
    "Description": "How do you lead Employees, to emerge Stronger from Uncertainty and Change? We want to help you positively influence the impact of social distancing and working remotely. How? Check in with your teams quickly and continuously, Our solution enables you – as an Organizational Leader – to measure and improve the scientifically vetted factors, that now determine your (remote) culture. Employees complete a simple survey within 60 seconds, via email or app, completely anonymously. We developed a free (science based) 8 week continuous measuring program to set a baseline, monitor mood and measure effect.",
    "Discount": "Free for 2 months",
    "Does it drive you into a paid account": "Maybe, after 2 months",
    "Requirement": "For all teams and organizations with 6 or more members! E-mails required, completely secure and anonymous.",
    "Favicon": "Request via website",
    "How to apply (text)": "Sign up via website, our experts will help you set up successfully!",
    "How to apply (URL or email)": "https://2daysmood.com/en/remote-experience-monitor/",
    "More info URL": "https://2daysmood.com/en/remote-experience-monitor/"
  },
  {
    "Name": "Document360",
    "Approved": "",
    "Category": "Writing Tools",
    "URL": "https://document360.io",
    "Description": "Document360 is a standalone Knowledge base platform for creating internal and customer-facing Knowledgebase",
    "Discount": "70% on all plans for 3 months",
    "Does it drive you into a paid account": "Maybe, after 3 months",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Sign up and send an email with COVID19 discount code to support@document360.io",
    "How to apply (URL or email)": "https://document360.io/signup/",
    "More info URL": ""
  },
  {
    "Name": "Snapshift",
    "Approved": "",
    "Category": "HR",
    "URL": "https://www.snapshift.co",
    "Description": "Snapshift is a workforce management application for food service and retail companies",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Sign up & create an account. The offer is already applied by default",
    "How to apply (URL or email)": "https://app.snapshift.co/",
    "More info URL": "https://www.snapshift.co/guide-covid-19"
  },
  {
    "Name": "Reply.io",
    "Approved": "",
    "Category": "Sales Tools",
    "URL": "https://reply.io/",
    "Description": "At Reply, we understand that businesses experience a downturn in sales in light of COVID-19. To support your business and help you maintain or even grow sales, we are giving away our newly developed unlimited email search for FREE and 20% off on Reply plans for new customers",
    "Discount": "Free unlimited email search and 20% off on Reply plans for new customers",
    "Does it drive you into a paid account": "the email search feature will remain free forever, the 20% discount is temporary",
    "Requirement": "available to new account only",
    "Favicon": "",
    "How to apply (text)": "Install our Chrome extension and use it to create a new Reply account",
    "How to apply (URL or email)": "https://reply.io/relief-offer/",
    "More info URL": ""
  },
  {
    "Name": "SellPro",
    "Approved": "",
    "Category": "Internal Communication",
    "URL": "https://www.sellpro.net",
    "Description": "Free Enterprise account for Retailers to be able to create content their furloughed or laid-off employees can use to keep in touch, so when things return, employees return.",
    "Discount": "Free until doors open again",
    "Does it drive you into a paid account": "Only if they like it once they have returned to business",
    "Requirement": "Available to retailers currently shut down due to Covid",
    "Favicon": "",
    "How to apply (text)": "Just create a basic account and we'll upgrade you free.",
    "How to apply (URL or email)": "https://info.sellpro.net/free-enterprise-solution-upgrade-for-retailers-sellpro",
    "More info URL": ""
  },
  {
    "Name": "evervault",
    "Approved": "",
    "Category": "Authentication",
    "URL": "https://www.evervault.com/",
    "Description": "evervault provides data privacy infrastructure for developers. evervault auth enables anonymous user authentication in a few lines of code.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Go to homepage and use COVID-19 banner to create account.",
    "How to apply (URL or email)": "https://app.evervault.com/",
    "More info URL": "https://www.evervault.com/"
  },
  {
    "Name": "Element Form",
    "Approved": "",
    "Category": "Data collection",
    "URL": "https://www.elementform.com/",
    "Description": "Secure Online Form Builder.\n\nFree and unrestricted license without any limitations.\n\nWe are offering 12 months free secure forms to all medical professionals, healthcare workers, aid workers, governments, nonprofits, individual doctors, nurses and private and government-owned hospitals.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Just sign up. All accounts are automatically upgraded after you register.",
    "How to apply (URL or email)": "https://editor.elementform.com/auth/register",
    "More info URL": "https://www.elementform.com/blog/coronavirus-covid19-free-license-program"
  },
  {
    "Name": "TourSolver",
    "Approved": "",
    "Category": "Delivery management",
    "URL": "https://www.toursolver.com/en/",
    "Description": "TourSolver is a route optimization solution available on the web which\nenables logistics coordinators, planners and any kind of mobile resources to\nsimply define optimized route schedules. 10 to 30% recognized\nproductivity gains and benefits!",
    "Discount": "100% for 3 months",
    "Does it drive you into a paid account": "Maybe, after 3 months",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Fill out the form",
    "How to apply (URL or email)": "https://www2.geoconcept.com/covid_free_toursolver",
    "More info URL": "https://www.toursolver.com/en/"
  },
  {
    "Name": "easyteo",
    "Approved": "",
    "Category": "Software editor",
    "URL": "https://www.easyteo.com",
    "Description": "Management and accounting software for companies",
    "Discount": "100%",
    "Does it drive you into a paid account": "Yes, after May 31, 2020",
    "Requirement": "New customers",
    "Favicon": "",
    "How to apply (text)": "Contact support",
    "How to apply (URL or email)": "https://www.easyteo.com/contact",
    "More info URL": "https://www.easyteo.com/abonnement-solidaire"
  },
  {
    "Name": "Teogest",
    "Approved": "",
    "Category": "Software editor",
    "URL": "https://teogest.com",
    "Description": "Accounting production tool for accountants and their clients",
    "Discount": "100%",
    "Does it drive you into a paid account": "Yes, after May 31, 2020",
    "Requirement": "New customers",
    "Favicon": "",
    "How to apply (text)": "Contact support",
    "How to apply (URL or email)": "http://www.teogest.com/contact",
    "More info URL": "https://www.teogest.com/abonnement-solidaire"
  },
  {
    "Name": "Kimp.io",
    "Approved": "",
    "Category": "Web/Graphic Design",
    "URL": "https://kimp.io",
    "Description": "Unlimited Graphic Design, unlimited revisions, unlimited brands. 7-Days free trial. Flat Monthly Fee. Save time and money with a dedicated design team. Kimp is for startups, SMEs, marketers, creative agencies, entrepreneurs.",
    "Discount": "50%",
    "Does it drive you into a paid account": "Yes, after 7 days free trial",
    "Requirement": "First time users",
    "Favicon": "//q5g9j9b9.stackpathcdn.com/wp-content/themes/kimpan/assets/images/favicon.png",
    "How to apply (text)": "Just sign up, discount applied already.",
    "How to apply (URL or email)": "https://kimp.io",
    "More info URL": ""
  },
  {
    "Name": "Hearapp.co",
    "Approved": "",
    "Category": "Productivity Tools",
    "URL": "https://hearapp.co",
    "Description": "Meeting scheduler with collaborative agenda, actionables & meeting notes. For just $5/month.",
    "Discount": "50%",
    "Does it drive you into a paid account": "Yes, after 7 days free trial",
    "Requirement": "First time users",
    "Favicon": "",
    "How to apply (text)": "Sign up, and the rest will follow",
    "How to apply (URL or email)": "https://hearapp.co/",
    "More info URL": "https://hearapp.co/"
  },
  {
    "Name": "Lunsj",
    "Approved": "",
    "Category": "HR",
    "URL": "https://www.lunsjapp.com/",
    "Description": "Get to know your teammates, grow social connection among colleagues, and build cohesive relationships across your organization - in the office or remote.",
    "Discount": "50%",
    "Does it drive you into a paid account": "Yes, upgrading to a paid tier",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Get started by visiting our website",
    "How to apply (URL or email)": "https://www.lunsjapp.com/",
    "More info URL": "https://www.lunsjapp.com/"
  },
  {
    "Name": "Linknge",
    "Approved": "",
    "Category": "Website Tools",
    "URL": "https://linknge.com",
    "Description": "Create your own Whatsapp Click to Chat easily, or shorten your URL, and you can see the statistics!",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "just use the application",
    "How to apply (URL or email)": "https://linknge.com",
    "More info URL": "https://linknge.com"
  },
  {
    "Name": "Cascade Strategy",
    "Approved": "",
    "Category": "Other (add in tab \"Categories\")",
    "URL": "https://www.executestrategy.net/freecascade",
    "Description": "Build your strategic plan and share it with your team - then execute! 3 months FREE!",
    "Discount": "100%",
    "Does it drive you into a paid account": "no, you must enter a credit card but can cancel before the 3 FREE months!",
    "Requirement": "none",
    "Favicon": "",
    "How to apply (text)": "https://www.executestrategy.net/freecascade",
    "How to apply (URL or email)": "https://www.executestrategy.net/freecascade",
    "More info URL": "https://www.executestrategy.net/"
  },
  {
    "Name": "Stickies.io",
    "Approved": "",
    "Category": "Productivity Tools",
    "URL": "https://stickies.io/",
    "Description": "Stickies is a free tool we developed that allows teams to create, move, cluster and upvote stickies in real-time. Perfect for affinity maps, retrospectives and brainstorming sessions.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Just sign up",
    "How to apply (URL or email)": "https://stickies.io/",
    "More info URL": "https://www.carbonfive.com/"
  },
  {
    "Name": "Vitally",
    "Approved": "",
    "Category": "Analytics",
    "URL": "https://vitally.io/",
    "Description": "Customer health is business health. Vitally makes customer retention easy so Customer Success teams can keep both in good standing",
    "Discount": "100% till July 31, 2020",
    "Does it drive you into a paid account": "No",
    "Requirement": "B2B SaaS businesses involved in COVID-19 relief efforts",
    "Favicon": "",
    "How to apply (text)": "Sign up and fill out the form",
    "How to apply (URL or email)": "https://vitally.io/covid-support/",
    "More info URL": "https://vitally.io/covid-support/"
  },
  {
    "Name": "SaaSketeer",
    "Approved": "",
    "Category": "Other (add in tab \"Categories\")",
    "URL": "https://saasketeer.com/",
    "Description": "SaaSketeer is a secondary marketplace for prepaid subscription plans where you can list your software subscription plan for sale, and offer it to others at a discounted price.",
    "Discount": "100%",
    "Does it drive you into a paid account": "no",
    "Requirement": "none",
    "Favicon": "",
    "How to apply (text)": "We aren’t going to charge any fee on it - it’s completely free to use",
    "How to apply (URL or email)": "https://saasketeer.com/",
    "More info URL": "https://saasketeer.com/frequently-asked-questions"
  },
  {
    "Name": "Boost.link",
    "Approved": "",
    "Category": "Lead generation",
    "URL": "https://start.boost.link",
    "Description": "Boost is a unique email list building tool that uses social network APIs to quickly create opt-in links so you can generate more leads.",
    "Discount": "We’re giving away 300 1-year licenses for the Pro plan",
    "Does it drive you into a paid account": "No. The user can choose to continue or not after 1 year.",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Sign-up via form to continue email address",
    "How to apply (URL or email)": "https://start.boost.link/trial-page/",
    "More info URL": "https://start.boost.link/plans/"
  },
  {
    "Name": "Scapic",
    "Approved": "",
    "Category": "Lead generation",
    "URL": "https://scapic.com",
    "Description": "Bringing immersive commerce to the next billion Indians",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Small businesses, retailers and online stores",
    "Favicon": "",
    "How to apply (text)": "Contact Support",
    "How to apply (URL or email)": "https://scapic.com/covid19/",
    "More info URL": "https://scapic.com/covid19/"
  },
  {
    "Name": "LimeCall",
    "Approved": "",
    "Category": "Sales Tools",
    "URL": "https://limecall.com",
    "Description": "The smartest way to generate more sales qualified leads and calls from your website visitors with targeted automation and real-time multi channel integrations.",
    "Discount": "Offer 1 - 100% off for 6 months",
    "Does it drive you into a paid account": "No. The user can choose to continue or not after 6 Months.",
    "Requirement": "NGO/Early stage startups with less than 25 employees",
    "Favicon": "",
    "How to apply (text)": "Fill Form, Discount code - \" SaaSforCovid\"  after you signup during checkout",
    "How to apply (URL or email)": "https://limecall.com/covid",
    "More info URL": "https://limecall.com/covid"
  },
  {
    "Name": "Afi SaaS backup",
    "Approved": "",
    "Category": "Backup",
    "URL": "https://afi.ai/",
    "Description": "Modern SaaS backup plaform for Microsoft Office 365 and Google G Suite. afi.ai",
    "Discount": "100% free for 6 month",
    "Does it drive you into a paid account": "No. User can choose to stop using the service after 6 month.",
    "Requirement": "Helthcare and educational organizations",
    "Favicon": "",
    "How to apply (text)": "Sign up.",
    "How to apply (URL or email)": "https://afi.ai/",
    "More info URL": "https://afi.ai/"
  },
  {
    "Name": "Jostle",
    "Approved": "",
    "Category": "Internal Communication",
    "URL": "https://jostle.me",
    "Description": "To help support organizations making the switch to remote work, we are offering a new Remote Work Package for free for 60 days",
    "Discount": "100%",
    "Does it drive you into a paid account": "Yes, after 60 days but no credit card asked for up front",
    "Requirement": "New customers",
    "Favicon": "",
    "How to apply (text)": "Fill out form",
    "How to apply (URL or email)": "https://intranet.jostle.me/remote-work-offer",
    "More info URL": "https://www.jostle.me"
  },
  {
    "Name": "Badrap",
    "Approved": "",
    "Category": "Cybersecurity",
    "URL": "https://hygiene.badrap.io/remote-work/",
    "Description": "We're making our cybersecurity course totally free for individuals and small companies. Many of us are now working from home like never before. Fortunately, you have social superpowers: Communication, Collaboration, and Community. You can use them to stay safe online and work safely.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Individuals and small companies",
    "Favicon": "",
    "How to apply (text)": "Just sign up",
    "How to apply (URL or email)": "https://hygiene.badrap.io/remote-work/",
    "More info URL": ""
  },
  {
    "Name": "Hiver",
    "Approved": "",
    "Category": "Email",
    "URL": "https://hiverhq.com/covid-19?utm_source=saasforcovid&utm_medium=website",
    "Description": "Hiver is a team email collaboration tool which helps teams manage group email inboxes like support@, info@, etc., without leaving Gmail. To help aid in the fight against COVID-19, we are offering eligible businesses Hiver free for two months on our elite plan.",
    "Discount": "100% till June 30, 2020",
    "Does it drive you into a paid account": "No. User can choose to stop using the product after 60 days, or choose to sign up for any of our regular plans.",
    "Requirement": "Small businesses which fall into either of the following categories: first responders, public health, hospitals, food/grocery delivery services, PPE providers, NGOs",
    "Favicon": "",
    "How to apply (text)": "Sign up form from the given page",
    "How to apply (URL or email)": "https://hiverhq.com/covid-19",
    "More info URL": ""
  },
  {
    "Name": "PPC Protect",
    "Approved": "",
    "Category": "Cybersecurity",
    "URL": "https://ppcprotect.com",
    "Description": "Next generation click fraud protection for Google Ads advertisers",
    "Discount": "100% for 3 months",
    "Does it drive you into a paid account": "No",
    "Requirement": "New customers only",
    "Favicon": "",
    "How to apply (text)": "Sign up and reach out to our support team",
    "How to apply (URL or email)": "https://ppcprotect.com/register",
    "More info URL": "https://ppcprotect.com"
  },
  {
    "Name": "Hotjar",
    "Approved": "",
    "Category": "Analytics",
    "URL": "https://www.hotjar.com",
    "Description": "Hotjar is Behavior Analytics software that makes it easy to go beyond traditional web analytics and understand what users are really doing on your site.",
    "Discount": "90-day free Business trial",
    "Does it drive you into a paid account": "No. The user can choose to continue or not after 3 Months and will have access to the Basic version.",
    "Requirement": "New customers only",
    "Favicon": "",
    "How to apply (text)": "Use the link provided in the next column :)",
    "How to apply (URL or email)": "https://htjr.io/saasforcovid",
    "More info URL": "https://htjr.io/saasforcovid"
  },
  {
    "Name": "LiveChat",
    "Approved": "",
    "Category": "Marketing/ LiveChat",
    "URL": "https://www.livechat.com",
    "Description": "",
    "Discount": "50% of annual payment + custom extended trial according to company's needs",
    "Does it drive you into a paid account": "Maybe. No credit card details required, but you might want to subscribe.",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Sign up; you can reach up for our chat support anytime for more details.",
    "How to apply (URL or email)": "https://www.livechat.com",
    "More info URL": "https://www.livechat.com/success/we-are-ready-to-support-you/"
  },
  {
    "Name": "AfterShip",
    "Approved": "",
    "Category": "Delivery management",
    "URL": "https://www.aftership.com/",
    "Description": "The #1 Tracking Solution for eCommerce Businesses. Track and trace all shipments across 666+ carriers worldwide in one place.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Free forever plan (less than 50 trackings per month）",
    "Favicon": "Just signup.",
    "How to apply (text)": "Just signup",
    "How to apply (URL or email)": "https://www.aftership.com",
    "More info URL": "https://blog.aftership.com/forever-free-plan-covid-19/"
  },
  {
    "Name": "Canva for Enterprise",
    "Approved": "",
    "Category": "Web/Graphic Design",
    "URL": "https://www.canva.com/enterprise/remote-work-offer/",
    "Description": "Canva for Enterprise is a design tool that helps everyone create and collaborate on beautiful designs from over 60,000 templates and millions of free photos and graphics as well as features for productivity, customization, collaboration and brand management.",
    "Discount": "6 months free",
    "Does it drive you into a paid account": "Yes, after 6 months and heavy requirements (including card on file)",
    "Requirement": "10 team members required",
    "Favicon": "",
    "How to apply (text)": "Just signup via button below",
    "How to apply (URL or email)": "https://www.canva.com/enterprise/remote-work-offer/",
    "More info URL": "https://www.canva.com/enterprise/remote-work-offer/"
  },
  {
    "Name": "HubSpot",
    "Approved": "",
    "Category": "Marketing Automation",
    "URL": "www.hubspot.com",
    "Description": "HubSpot offers a full platform of marketing, sales, customer service, and CRM software — plus the methodology, resources, and support - to help businesses grow better. Our top priority is the health and safety of our employees and of the communities we serve, including our customers, partners, prospects, and candidates. This page outlines details of the support measures we’ve introduced so far that we hope will help you to adapt to these times.",
    "Discount": "55% off for 12 months, plus additional unlocked features in the free version of our tools and increased usage limits for 90 days",
    "Does it drive you into a paid account": "Yes, but we have a free version of our product suite that will have enhanced functionality for 90 days",
    "Requirement": "Listed on page",
    "Favicon": "",
    "How to apply (text)": "Sign up on page",
    "How to apply (URL or email)": "https://offers.hubspot.com/customer-changes-march-2020",
    "More info URL": "https://offers.hubspot.com/customer-changes-march-2020"
  },
  {
    "Name": "Instabug",
    "Approved": "",
    "Category": "Developer Tools",
    "URL": "https://instabug.com/",
    "Description": "The #1 SDK Delivering Real-Time Contextual Insights throughout the entire mobile app lifecycle, empowering mobile teams to accelerate their workflow and release with confidence. Crash reporting + Bug reporting + Customizable in-app surveys all in one SDK.",
    "Discount": "100% for 3 Months",
    "Does it drive you into a paid account": "Yes",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Use Promocode: SaaSForCovid19",
    "How to apply (URL or email)": "https://instabug.com/",
    "More info URL": ""
  },
  {
    "Name": "Omnisend",
    "Approved": "",
    "Category": "Email",
    "URL": "https://www.omnisend.com/",
    "Description": "Omnisend is an all-in-one email marketing automation platform built for growth-focused ecommerce brands. Convert visitors into customers, create personalized emails in minutes, and automate your email marketing.",
    "Discount": "50% for 2 months for Standard plan, valid until June 30",
    "Does it drive you into a paid account": "Maybe, it's a discount and expires after June 30",
    "Requirement": "New customers only",
    "Favicon": "",
    "How to apply (text)": "Use Promocode: INTHISTOGETHER50X2",
    "How to apply (URL or email)": "https://www.omnisend.com/",
    "More info URL": "https://www.omnisend.com/blog/crisis-marketing/"
  },
  {
    "Name": "Pequity",
    "Approved": "",
    "Category": "HR",
    "URL": "https://www.getpequity.com/",
    "Description": "Pequity makes pay and equity easy, with a single hub for managing pay philosophy and ranges, making data-driven pay decisions, optimizing offer workflows, and flagging pay inequalities.",
    "Discount": "for companies, recruiters, and compensation teams that are impacted by COVID-19.",
    "Does it drive you into a paid account": "Yes",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Via the COVID-19 page contact form",
    "How to apply (URL or email)": "https://www.getpequity.com/covid-19.html#section_contact",
    "More info URL": "https://www.getpequity.com/covid-19.html"
  },
  {
    "Name": "Postmen",
    "Approved": "",
    "Category": "Delivery management",
    "URL": "https://www.postmen.com/",
    "Description": "Scalable shipping software & API for eCommerce businesses. Enjoy the lowest USPS shipping rates for free.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Free forever plan",
    "Favicon": "Just signup",
    "How to apply (text)": "Just signup",
    "How to apply (URL or email)": "https://secure.postmen.com/login",
    "More info URL": "https://www.postmen.com/pricing"
  },
  {
    "Name": "MightyForms",
    "Approved": "",
    "Category": "Data collection",
    "URL": "https://www.mightyforms.com",
    "Description": "We’re in this together. MightyForms wants to help you help more people. Unlimited forms and features for not-for-profit Coronavirus related projects or campaigns.",
    "Discount": "Free, until October 1st, 2020",
    "Does it drive you into a paid account": "Maybe. After October 1st.",
    "Requirement": "Nonprofit Covid-19 response project",
    "Favicon": "",
    "How to apply (text)": "",
    "How to apply (URL or email)": "https://www.mightyforms.com/coronavirus-response-offer/",
    "More info URL": ""
  },
  {
    "Name": "Pipefy",
    "Approved": "",
    "Category": "Productivity Tools",
    "URL": "https://www.pipefy.com/",
    "Description": "The unconventional scenario created by COVID-19 is requiring teams to adapt to remote work overnight. Pipefy is a workflow management tool to help ensure communication flows easily, optimize resources and enable teams to stay productive even while remote. We also have free templates created specifically to help with remote work.",
    "Discount": "10% off first 3 months. Free for NGO's.",
    "Does it drive you into a paid account": "We have a free version of our product and can upgrade for paid for more features",
    "Requirement": "New customers only",
    "Favicon": "",
    "How to apply (text)": "Use the chat widget to discuss the discount",
    "How to apply (URL or email)": "https://www.pipefy.com/remote-workflow-process-management/",
    "More info URL": ""
  },
  {
    "Name": "ProjectSet",
    "Approved": "",
    "Category": "Edtech",
    "URL": "https://projectset.com/",
    "Description": "Conduct internships and curriculum-based projecs remotely on our online platform. Enjoy free access to project tools (e.g. workplans, messaging, file-sharing, etc.) and the option to involve mentors.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Sign up online",
    "How to apply (URL or email)": "https://projectset.com/login",
    "More info URL": "https://projectset.com/faq"
  },
  {
    "Name": "Kintell",
    "Approved": "",
    "Category": "Edtech",
    "URL": "https://kintell.com/",
    "Description": "",
    "Discount": "$20 credit upon signup",
    "Does it drive you into a paid account": "Maybe, it's a credit",
    "Requirement": "New users only",
    "Favicon": "",
    "How to apply (text)": "Just sign up, discount applied already.",
    "How to apply (URL or email)": "https://kintell.com/join-now",
    "More info URL": "https://kintell.com/pricing"
  },
  {
    "Name": "Rentman",
    "Approved": "",
    "Category": "Project Management",
    "URL": "https://rentman.io",
    "Description": "Rentman is a scalable resource management software that helps you schedule resources, track inventory and create professional quotes in an easy to use system",
    "Discount": "100% off for 3 months",
    "Does it drive you into a paid account": "No, the 3 free months end by themselves unless you activate your account.",
    "Requirement": "New users only",
    "Favicon": "",
    "How to apply (text)": "Just sign up",
    "How to apply (URL or email)": "https://rentman.io",
    "More info URL": ""
  },
  {
    "Name": "MeeroDrop",
    "Approved": "",
    "Category": "Remote Work",
    "URL": "https://www.meerodrop.com",
    "Description": "MeeroDrop is a free file sharing platform, particularly suited for visual content.\nTransfers up to 10 Gb and stored for 90 days (vs. 5 Gb and 30 days usually)",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Just go on www.meerodrop.com",
    "How to apply (URL or email)": "https://www.meerodrop.com",
    "More info URL": "https://www.meerodrop.com/en/about"
  },
  {
    "Name": "HR Partner",
    "Approved": "",
    "Category": "HR",
    "URL": "https://www.hrpartner.io/",
    "Description": "HR Partner is the HR system for businesses with 20-500 employees. It manages employee records, onboarding, recruiting, leave requests and more.",
    "Discount": "50% off for 6 months",
    "Does it drive you into a paid account": "Maybe, if they continue after their first 6 months",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Start a free trial at www.hrpartner.io, then use coupon code \"COVID50\" to get this discount",
    "How to apply (URL or email)": "https://app.hrpartner.io/user/signup",
    "More info URL": "https://www.hrpartner.io/"
  },
  {
    "Name": "PC Matic",
    "Approved": "",
    "Category": "Cybersecurity",
    "URL": "www.pcmatic.com/covid19",
    "Description": "PC Matic is offering free cybersecurity and remote management tools for businesses, government entities and educational insitutions.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "Businesses with more than five endpoints, or be a managed service provider.",
    "Favicon": "",
    "How to apply (text)": "Sign up at www.pcmatic.com/covid19",
    "How to apply (URL or email)": "www.pcmatic.com/covid19",
    "More info URL": "www.pcmatic.com/covid19"
  },
  {
    "Name": "Userback",
    "Approved": "",
    "Category": "Website Tools",
    "URL": "https://www.userback.io",
    "Description": "Userback is a visual feedback tool that makes it easy to collect feedback from any webpage. It's like seeing a website through your customer's eyes with screenshots and annotations.",
    "Discount": "50% off all annual plans",
    "Does it drive you into a paid account": "Maybe, it's a discount. However we also have a free plan.",
    "Requirement": "New customers only",
    "Favicon": "",
    "How to apply (text)": "Just signup via button below",
    "How to apply (URL or email)": "https://www.userback.io/?c=covidsupport",
    "More info URL": "https://www.userback.io"
  },
  {
    "Name": "Reallusion Software",
    "Approved": "",
    "Category": "Software editor",
    "URL": "https://www.reallusion.com/COVID-19.html",
    "Description": "",
    "Discount": "A 50% discount on all packages in the Reallusion Software Store",
    "Does it drive you into a paid account": "No.",
    "Requirement": "New and existing members. Valid through April 30th, 2020.",
    "Favicon": "",
    "How to apply (text)": "Sign up via button below and enter the 50% off coupon code “COVID19STAYSAFE” during checkout.",
    "How to apply (URL or email)": "https://www.reallusion.com/COVID-19.html",
    "More info URL": "https://www.reallusion.com/COVID-19.html"
  },
  {
    "Name": "Virushee",
    "Approved": "",
    "Category": "Cybersecurity",
    "URL": "https://virushee.com",
    "Description": "Privacy-oriented file scanning service enchanted by AI and Heuristic Engines. Additional, dynamic sandbox analysis available. Allows integration via REST API.",
    "Discount": "Free during COVID-19",
    "Does it drive you into a paid account": "No",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Just go to virushee.com",
    "How to apply (URL or email)": "https://virushee.com",
    "More info URL": "https://virushee.com"
  },
  {
    "Name": "Starred",
    "Approved": "",
    "Category": "HR",
    "URL": "https://www.starred.com",
    "Description": "Starred is a feedback software for HR and Talent Acquisition to gather actionable insights into the experiences of employees and candidates.",
    "Discount": "Free during COVID-19",
    "Does it drive you into a paid account": "No",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Get your access on the website",
    "How to apply (URL or email)": "https://www.starred.com/debra-corey-engagement-survey",
    "More info URL": ""
  },
  {
    "Name": "Simplicité Software",
    "Approved": "",
    "Category": "Low-Code/No-Code",
    "URL": "https://simplicitesoftware.com",
    "Description": "Simplicité is a universal Low-code platform designed to easily and quickly create custom enterprise applications and scalable SaaS services.",
    "Discount": "100% for 3 months",
    "Does it drive you into a paid account": "No",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Just go to url and \"start now",
    "How to apply (URL or email)": "https://simplicitesoftware.com/platform/pricing/",
    "More info URL": "https://simplicitesoftware.com"
  },
  {
    "Name": "CotractNow",
    "Approved": "",
    "Category": "Contract Management",
    "URL": "https://www.contractnow.com/",
    "Description": "ContractNow is a simple, powerful contract management solution specifically designed to answer the business’s key contracting questions during COVID-19 and beyond. It’s currently offered completely free of charge until 1st September 2020.",
    "Discount": "100% Free Until Sept 1st 2020",
    "Does it drive you into a paid account": "No",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Visit www.contractnow.com and request access",
    "How to apply (URL or email)": "https://www.contractnow.com/",
    "More info URL": "https://www.contractnow.com/"
  },
  {
    "Name": "ShipStation",
    "Approved": "",
    "Category": "eCommerce Software",
    "URL": "https://www.shipstation.com/",
    "Description": "Wherever you sell, however you ship, ShipStation makes you exceptionally efficient at syncing, managing, and shipping your orders.",
    "Discount": "100% Free for 3 months",
    "Does it drive you into a paid account": "Yes, after 3 month trial expires",
    "Requirement": "New customers only",
    "Favicon": "",
    "How to apply (text)": "Use offer code: letushelp90",
    "How to apply (URL or email)": "https://www.shipstation.com/let-shipstation-help/",
    "More info URL": "https://www.shipstation.com/covid-19/"
  },
  {
    "Name": "SatisMeter",
    "Approved": "",
    "Category": "Customer Feedback",
    "URL": "https://www.satismeter.com/",
    "Description": "Worried about losing customers during the coronavirus outbreak? Use our FREE COVID-19 Survey  and get a customer health report to help you take action and plan better.",
    "Discount": "100%",
    "Does it drive you into a paid account": "No",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Sign Up",
    "How to apply (URL or email)": "https://www.satismeter.com/covid19/",
    "More info URL": "https://www.satismeter.com/covid19/"
  },
  {
    "Name": "Joomla51",
    "Approved": "",
    "Category": "CMS",
    "URL": "joomla51.com/",
    "Description": "Joomla51.com provide professional templates and extensions. For 10 years, users have enjoyed our great designs and excellent support.",
    "Discount": "30%",
    "Does it drive you into a paid account": "No",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Coupon code: \tCOVIDRELIEF",
    "How to apply (URL or email)": "joomla51.com/",
    "More info URL": "joomla51.com/"
  },
  {
    "Name": "TrustedSite",
    "Approved": "",
    "Category": "Website Tools",
    "URL": "https://www.trustedsite.com/",
    "Description": "TrustedSite certifications help to convert customers at every stage of the sales funnel. Each of our trustmarks are tailored to increase a specific type of conversion, from lead generation to ecommerce sales.",
    "Discount": "Free through the end of 2020.",
    "Does it drive you into a paid account": "No, subscription will be canceled 12/31/2020.",
    "Requirement": "Nonprofit providing COVID-19 relief.",
    "Favicon": "",
    "How to apply (text)": "Fill out our form",
    "How to apply (URL or email)": "https://blog.trustedsite.com/2020/04/23/trustedsites-support-for-covid-19-response-efforts/",
    "More info URL": ""
  },
  {
    "Name": "CheckMarket",
    "Approved": "",
    "Category": "HR",
    "URL": "https://www.checkmarket.com/covid-19-screening-form-template/",
    "Description": "Use our Coronavirus screening questionnaire and reporting template to quickly setup pre-shift screening of your employees or visitors. No software to install. Runs in the browser on PCs, tablets and smartphones.",
    "Discount": "50%",
    "Does it drive you into a paid account": "Maybe",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Sign up and chose COVID-19 form template",
    "How to apply (URL or email)": "https://www.checkmarket.com/covid-19-screening-form-template/",
    "More info URL": "https://www.checkmarket.com/covid-19-screening-form-template/"
  },
  {
    "Name": "SocialPilot",
    "Approved": "",
    "Category": "Marketing Automation",
    "URL": "https://www.socialpilot.co",
    "Description": "Simple & Cost-Effective Social Media Marketing Tool for Teams and Agencies",
    "Discount": "$1/month",
    "Does it drive you into a paid account": "Yes, after first 2 months.",
    "Requirement": "New customers only",
    "Favicon": "",
    "How to apply (text)": "Sign Up",
    "How to apply (URL or email)": "https://www.socialpilot.co/we-want-to-help",
    "More info URL": "https://www.socialpilot.co/we-want-to-help"
  },
  {
    "Name": "Sparkhouse",
    "Approved": "",
    "Category": "Marketing Automation",
    "URL": "https://thesparkhouse.com/support-local/",
    "Description": "We came up with the idea to do what we do best—make videos—for local businesses for FREE.",
    "Discount": "100%",
    "Does it drive you into a paid account": "Every week 1/2 videos",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Fill out our form",
    "How to apply (URL or email)": "https://thesparkhouse.com/support-local/",
    "More info URL": "https://thesparkhouse.com/support-local/"
  },
  {
    "Name": "Lumavate",
    "Approved": "",
    "Category": "Mobile App",
    "URL": "https://www.lumavate.com/",
    "Description": "",
    "Discount": "100% for 90 days",
    "Does it drive you into a paid account": "No; Companies can choose to purchase the platform after 90 days if desired or stop using the platform at the end of 90 days.",
    "Requirement": "New customers only; Must have valid company email address",
    "Favicon": "",
    "How to apply (text)": "Fill out form",
    "How to apply (URL or email)": "https://www.lumavate.com/offers/",
    "More info URL": "https://www.lumavate.com/offers/"
  },
  {
    "Name": "Gmelius",
    "Approved": "",
    "Category": "Remote Work",
    "URL": "https://gmelius.com",
    "Description": "Gmelius is the first collaboration platform that integrates with your tools and connects your teams. No more data migration, Bcc, forward, endless copy-pasting.",
    "Discount": "3 months of Gmelius Plus for Free",
    "Does it drive you into a paid account": "Yes, after first 3 months",
    "Requirement": "Any non-political humanitarian group that is working on COVID-19 relief efforts.",
    "Favicon": "",
    "How to apply (text)": "Sign up",
    "How to apply (URL or email)": "contact success@gmelius.com",
    "More info URL": "https://community.gmelius.com/t/working-on-covid-19-relief-efforts-use-gmelius-for-free"
  },
  {
    "Name": "Appify",
    "Approved": "",
    "Category": "Restaurant Online Ordering",
    "URL": "https://www.wurk.com.au/appify",
    "Description": "Online Ordering Software built for local restaurants and takeaways that dont want to pay high commissions.",
    "Discount": "100% free for 3 months",
    "Does it drive you into a paid account": "Yes, after first 3 months",
    "Requirement": "New Customers Only",
    "Favicon": "",
    "How to apply (text)": "Signup",
    "How to apply (URL or email)": "https://www.wurk.com.au/hubspot-referral",
    "More info URL": "https://www.wurk.com.au/appify"
  },
  {
    "Name": "Pulno",
    "Approved": "",
    "Category": "Website Tools",
    "URL": "https://www.pulno.com",
    "Description": "SEO Audit tool with backlink monitoring, changes monitoring and thin content detection",
    "Discount": "100% free during pandemic",
    "Does it drive you into a paid account": "No",
    "Requirement": "none",
    "Favicon": "",
    "How to apply (text)": "contact support@pulno.com for a plan upgrade",
    "How to apply (URL or email)": "support@pulno.com",
    "More info URL": "https://www.pulno.com"
  },
  {
    "Name": "Netlify",
    "Approved": "",
    "Category": "Hosting",
    "URL": "https://www.netlify.com/",
    "Description": "CDN, Continuous deployment, 1-click HTTPS, and more for static websites.",
    "Discount": "100% Free Pro Plan for 6 months",
    "Does it drive you into a paid account": "Maybe, reverts to free plan after 6 months",
    "Requirement": "Free services for those who are creating sites, apps, and tools that help people understand this virus",
    "Favicon": "",
    "How to apply (text)": "Fill out the COVID-19 application form",
    "How to apply (URL or email)": "https://covid19-support.netlify.com/",
    "More info URL": "https://www.netlify.com/blog/2020/03/22/coronavirus/covid-19-support/"
  },
  {
    "Name": "Taskade",
    "Approved": "",
    "Category": "Productivity Tools",
    "URL": "https://www.taskade.com/",
    "Description": "Real-time organization and collaboration tool for remote teams.",
    "Discount": "100% Free. Restrictions removed on Free Plan.",
    "Does it drive you into a paid account": "Maybe, after 6 months.",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Automatic",
    "How to apply (URL or email)": "",
    "More info URL": "https://www.taskade.com/new"
  },
  {
    "Name": "Foleon",
    "Approved": "",
    "Category": "Content Marketing",
    "URL": "https://www.foleon.com",
    "Description": "The content experience platform Foleon offers a Free COVID-19 communications template, 2 free users, and a discount on creative services",
    "Discount": "2 free users and 20% on creative services until the 1st of June",
    "Does it drive you into a paid account": "Yes",
    "Requirement": "For customers",
    "Favicon": "",
    "How to apply (text)": "Sign up",
    "How to apply (URL or email)": "https://www.foleon.com/get-started",
    "More info URL": "https://www.foleon.com/blog/how-the-new-normal-can-be-a-catalyst-for-upgrading-for-your-content-strategy"
  },
  {
    "Name": "VBOUT",
    "Approved": "",
    "Category": "Marketing Automation",
    "URL": "www.vbout.com",
    "Description": "VBOUT is an adaptive marketing automation stack for lean marketing teams.",
    "Discount": "A free plan during 3 months.",
    "Does it drive you into a paid account": "Yes, after 3 months.",
    "Requirement": "For any businesses impacted by COVID-19",
    "Favicon": "",
    "How to apply (text)": "Sign up",
    "How to apply (URL or email)": "https://lp.vbt.site/10726/marketing-support-for-businesses-affected-by-coronavirus/",
    "More info URL": "https://lp.vbt.site/10726/marketing-support-for-businesses-affected-by-coronavirus/"
  },
  {
    "Name": "Techsign DOC",
    "Approved": "",
    "Category": "Contract Management",
    "URL": "https://www.techsigndoc.com/en/",
    "Description": "Techsign DOC is a document signing platform for businesses of all sizes. The Agreement Cloud provides verifiable and legally binding digital signing options and a comprehensive tool set for document management proposing the values listed below:",
    "Discount": "100% free during pandemic",
    "Does it drive you into a paid account": "No; Companies can choose to purchase the platform after 90 days if desired or stop using the platform at the end of 90 days.",
    "Requirement": "New customers only",
    "Favicon": "",
    "How to apply (text)": "Register regularly",
    "How to apply (URL or email)": "https://www.techsigndoc.com/register.html",
    "More info URL": "https://www.techsigndoc.com/en/blog/a-quick-look-at-electronic-signatures-in-covid-19-times"
  },
  {
    "Name": "Cidewalk",
    "Approved": "",
    "Category": "Ads",
    "URL": "https://www.cidewalk.com/freeads.html",
    "Description": "FREE Gift Card Promotion (value $100. Now free) Consumers across the nation are showing support for their favorite local businesses by purchasing online gift certificates. CIdewalk is giving businesses a chance to promote their gift card",
    "Discount": "100% free. 1 month of free ads.",
    "Does it drive you into a paid account": "Yes",
    "Requirement": "New customers.",
    "Favicon": "",
    "How to apply (text)": "Online form",
    "How to apply (URL or email)": "https://www.cidewalk.com/freeads.html",
    "More info URL": "https://www.cidewalk.com/"
  },
  {
    "Name": "Eunimart",
    "Approved": "",
    "Category": "eCommerce Software",
    "URL": "www.vdezi.com",
    "Description": "Eunimart is a SaaS based crossborder ecommerce company helping businesses scale internationally using its AI based platform Vdezi",
    "Discount": "100% Free. Restrictions removed on All Paid Premium Features",
    "Does it drive you into a paid account": "Maybe, after 2 months",
    "Requirement": "New customers",
    "Favicon": "",
    "How to apply (text)": "Sign up",
    "How to apply (URL or email)": "go.vdezi.com/signup",
    "More info URL": "www.vdezi.com"
  },
  {
    "Name": "Iteratively",
    "Approved": "",
    "Category": "Analytics",
    "URL": "https://iterative.ly/",
    "Description": "Collaborate with your entire team to ship high-quality analytics faster and be confident in the results.",
    "Discount": "Free plan with 25 users.",
    "Does it drive you into a paid account": "No",
    "Requirement": "For anyone who's impacted by Covid19, we want to help them with accurate analytics & enable them to make better business decisions.",
    "Favicon": "",
    "How to apply (text)": "Sign-up",
    "How to apply (URL or email)": "https://app.iterative.ly/signup",
    "More info URL": ""
  },
  {
    "Name": "Netcore Smartech",
    "Approved": "",
    "Category": "Marketing Automation",
    "URL": "https://netcoresmartech.com/covid19?source=saasforcovid",
    "Description": "Product Recommendations and Personalization like the big guys. The AI-based platform lets you deliver dynamic web and app experiences based on real-time and past behaviour tracking of every unique user. Proven conversion jump of 8 to 13%.",
    "Discount": "100% free till Sept '20.",
    "Does it drive you into a paid account": "Maybe, after 5 months.",
    "Requirement": "Any Ecom, Grocery, OTT, News & Media & Content business with 100k+ monthly visitors.",
    "Favicon": "",
    "How to apply (text)": "Online form",
    "How to apply (URL or email)": "https://netcoresmartech.com/covid19?source=saasforcovid",
    "More info URL": "https://netcoresmartech.com/features/dynamic-website-personalization?source=saasforcovid"
  },
  {
    "Name": "Super Monitoring",
    "Approved": "",
    "Category": "Monitoring",
    "URL": "https://www.supermonitoring.com",
    "Description": "Monitoring commercial websites for their uptime (availability), content, loading speed, functions, domain & SSL certificate expiration and more. Immediate email & SMS alerts, cyclic & custom reports. Integrates directly with WordPress, Drupal, Joomla, Magento and PrestaShop. API available.",
    "Discount": "Extra\" subscription plan free for 3 months for SMBs affected by the pandemic.",
    "Does it drive you into a paid account": "Yes, after 3 months. But we don't charge automatically (no credit card required for the free offer).",
    "Requirement": "Small & Medium Businesses, affected by the COVID-19 pandemic.",
    "Favicon": "",
    "How to apply (text)": "Sign up & contact us via online form",
    "How to apply (URL or email)": "https://www.supermonitoring.com/p/covid-19",
    "More info URL": "https://www.supermonitoring.com/p/covid-19"
  },
  {
    "Name": "Howuku Analytics",
    "Approved": "",
    "Category": "Analytics",
    "URL": "https://howuku.con",
    "Description": "All-in-one feedback and analytics platform to help you truly understand your website visitors.",
    "Discount": "50% discount to all plans",
    "Does it drive you into a paid account": "No",
    "Requirement": "New customers",
    "Favicon": "",
    "How to apply (text)": "Checkout with discount code STAYHOME",
    "How to apply (URL or email)": "https://howuku.com",
    "More info URL": "https://howuku.com"
  },
  {
    "Name": "Inleven",
    "Approved": "",
    "Category": "URL Shortener",
    "URL": "https://inleven.com/covid19/",
    "Description": "A new and better way to shorten, track and share links with your team.",
    "Discount": "60% discount to all plans",
    "Does it drive you into a paid account": "Yes",
    "Requirement": "Anyone",
    "Favicon": "",
    "How to apply (text)": "Just sign up and use the Code  COVID-HELP",
    "How to apply (URL or email)": "https://inleven.com/covid19/",
    "More info URL": "https://inleven.com/"
  },
  {
    "Name": "Inkybay ‑ Product Customizer",
    "Approved": "",
    "Category": "Sales Tools",
    "URL": "https://inkybay.com/",
    "Description": "Inkybay - Product Customizer is a web-based application which provides the ultimate solution for business owners who want to enable self-customization options on their online stores. So, the customers can easily personalize the products according to their requirements, and place an order, and the store owners receive the print-ready vector files eventually.",
    "Discount": "Extended 45 days free trial",
    "Does it drive you into a paid account": "Maybe, after 45 days.",
    "Requirement": "New installatios",
    "Favicon": "",
    "How to apply (text)": "Just install the app in your Shopify store",
    "How to apply (URL or email)": "https://apps.shopify.com/productsdesigner",
    "More info URL": "https://www.productsdesigner.com/blog/inkybay-offers-extended-trial-during-covid-19/"
  },
  {
    "Name": "Quick Base",
    "Approved": "",
    "Category": "Low-Code/No-Code",
    "URL": "https://www.quickbase.com/crisis-response",
    "Description": "A popular no-code/low-code platform to build custom applications including dashboards, project managent, field services management, HR and operations mangement",
    "Discount": "Free Access to Platform; Free Certification",
    "Does it drive you into a paid account": "Maybe, after 6 months.",
    "Requirement": "For healthcare providers, governments, educaional instituions, no profits",
    "Favicon": "",
    "How to apply (text)": "Signup",
    "How to apply (URL or email)": "https://www.quickbase.com/crisis-response#s9",
    "More info URL": "https://www.quickbase.com/about-us/media/quick-base-offers-free-solutions-and-expertise-to-help-organizations-deal-with-covid-19-disruption"
  },
  {
    "Name": "Oaky",
    "Approved": "",
    "Category": "Sales Tools",
    "URL": "https://www.oaky.com/free-oaky-corona",
    "Description": "The #1 Upselling Tool For Hotels. Integrates with the most popular PMS:es.",
    "Discount": "100% Free for 90 days.",
    "Does it drive you into a paid account": "No, no automatic extension.",
    "Requirement": "Anyone",
    "Favicon": "",
    "How to apply (text)": "Sign up via Link",
    "How to apply (URL or email)": "https://www.oaky.com/free-oaky-corona",
    "More info URL": "https://www.oaky.com/free-oaky-corona"
  },
  {
    "Name": "ParrotPolls.com",
    "Approved": "",
    "Category": "Remote Work",
    "URL": "https://www.parrotpolls.com/app/signup",
    "Description": "Missing the water-cooler while working remotely? Find out how your team is doing while working from home, and collect anonymous feedback.",
    "Discount": "12 month free. Ends automatically.",
    "Does it drive you into a paid account": "No, ends after 12 months.",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Just sign up via the link",
    "How to apply (URL or email)": "https://www.parrotpolls.com/app/signup",
    "More info URL": "https://www.parrotpolls.com"
  },
  {
    "Name": "Nifty PM",
    "Approved": "",
    "Category": "Project Management",
    "URL": "https://niftypm.com",
    "Description": "Nifty is your collaboration hub that makes tasks, timelines, and workloads clear to your team and clients.",
    "Discount": "Nifty is offering 50% off of all pricing plans for four months",
    "Does it drive you into a paid account": "No.",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Sign up and use code: REMOTE50",
    "How to apply (URL or email)": "https://niftypm.com",
    "More info URL": ""
  },
  {
    "Name": "Breezy HR",
    "Approved": "",
    "Category": "Recruitment",
    "URL": "https://breezy.hr",
    "Description": "End-to-end recruiting software to help you attract & hire great employees with less effort",
    "Discount": "Free Video Interviewing and video assessments on all plans",
    "Does it drive you into a paid account": "No",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Sign up",
    "How to apply (URL or email)": "https://app.breezy.hr/signup",
    "More info URL": "https://breezy.hr/blog/covid-19-hiring-remote-video-interviews-assessments"
  },
  {
    "Name": "Retro Rabbit",
    "Approved": "",
    "Category": "Remote Work",
    "URL": "https://retrorabbit.io",
    "Description": "Slack-First Retrospective Tool for teams working remotely. Add retro notes, action items, and run retrospective meetings.",
    "Discount": "25%",
    "Does it drive you into a paid account": "After 2 free retros, for teams larger than 5.",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Email support@retrorabbit.io",
    "How to apply (URL or email)": "support@retrorabbit.io",
    "More info URL": ""
  },
  {
    "Name": "Sam Weber",
    "Approved": "",
    "Category": "Brand Marketing",
    "URL": "https://1brand.co",
    "Description": "Custom brand guidelines built from your website in moments. Customized by you in minutes.",
    "Discount": "20% off for the first 2 years.",
    "Does it drive you into a paid account": "Freemium model with advanced customization unlocked through a subscription.",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Sign up and use the code: 2YearsTogether",
    "How to apply (URL or email)": "https://1brand.co",
    "More info URL": "https://1brand.co"
  },
  {
    "Name": "SprintCube",
    "Approved": "",
    "Category": "Website Builder",
    "URL": "https://www.sprintcube.com/webflow-design/",
    "Description": "Hire our team to build powerful websites, faster! We help professionals, startups, SME to save tons of hours in website production with our web design and Webflow skills.",
    "Discount": "Up to 45% off on a website",
    "Does it drive you into a paid account": "Yes",
    "Requirement": "We will help you with your website requirements based on your profession, business, goals.",
    "Favicon": "",
    "How to apply (text)": "Get in touch with us (Contact us form, Email, WhatsApp, Call)",
    "How to apply (URL or email)": "https://www.sprintcube.com/webflow-design/",
    "More info URL": "https://www.sprintcube.com/webflow-design/"
  },
  {
    "Name": "DigitalMaas",
    "Approved": "",
    "Category": "Shipping Software",
    "URL": "https://www.digitalmaas.com/",
    "Description": "Free Local Marketing Platform to help you manage your Google My Business Listings. Update information, reply to reviews, post covid updates to your cleints all in one place. Also integrates with Apple, Bing, Facebook , Instagram and others to ensure information is accurate across all these tools.",
    "Discount": "Free till 12th August 2020",
    "Does it drive you into a paid account": "if you wish, but not a requirement to claim support",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Visit the website and claim your free support",
    "How to apply (URL or email)": "https://www.digitalmaas.com/small-business-support-package/",
    "More info URL": "https://www.digitalmaas.com/small-business-support-package/"
  },
  {
    "Name": "Parsey",
    "Approved": "",
    "Category": "Marketing Automation",
    "URL": "parsey.com",
    "Description": "Many businesses struggle getting data from one platform to another. Often, this data is transactional, meaning it comes to them after an important event occurs. Examples are new leads or e-commerce order. Unless their platform has andative integration, this transactional data is sent to the business using a webhook or email. The business owner then must manually enter the data into their CRM or other application. \nParsey is an email and webhook parser that can automate this entire process, eliminating errors and costs associated with manual data entry. Now a business can direct transactional emails and webhooks to Parsey, which will extract and properly format the data, then send it to their preferred CRM or other sales and marketing applications.",
    "Discount": "2 Months free.",
    "Does it drive you into a paid account": "If you wish, but that is not required.",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Sign up for a free account at Parsey.com. The free account limits you to 100 total events. Once your account is created, contact support and tell them you'd like your COVID-19 2-month free account.",
    "How to apply (URL or email)": "https://parsey.com or support@parsey.com",
    "More info URL": ""
  },
  {
    "Name": "Wild Apricot",
    "Approved": "",
    "Category": "CRM",
    "URL": "https://www.wildapricot.com/covid19",
    "Description": "Wild Apricot is a complete membership management system. Easily manage your contacts, process payments, send out emails, register event attendees, create a website and more.",
    "Discount": "3 months free.",
    "Does it drive you into a paid account": "No.",
    "Requirement": "For any organization that's 100% dedicated to COVID-19 relief efforts",
    "Favicon": "",
    "How to apply (text)": "To get started, simply create an account with us and select COVID-19 as your organization type – if you qualify, we'll follow up with you in an email.",
    "How to apply (URL or email)": "https://www.wildapricot.com/covid19",
    "More info URL": ""
  },
  {
    "Name": "IdeaBuddy",
    "Approved": "",
    "Category": "Business Planning",
    "URL": "https://ideabuddy.com/pricing/",
    "Description": "IdeaBuddy is an application that offers guidance from the initial stage of business idea development, business model setup, financial forecast, competition comparison, business plan, one-page plan (business model canvas), and validation of the model. Guides and examples are included.",
    "Discount": "A yearly Founder plan with 3 ideas for only $49/year \n(regularly priced at $216/year)",
    "Does it drive you into a paid account": "Yes",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Head over to our pricing page\nSwitch to the yearly subscription\nSelect Founder plan with 3 ideas\nUse coupon FOUNDER3Y before checkout\nThis is a limited-time offer, so better hurry up",
    "How to apply (URL or email)": "https://ideabuddy.com/pricing/",
    "More info URL": ""
  },
  {
    "Name": "Chetaru",
    "Approved": "",
    "Category": "Web/Graphic Design",
    "URL": "http://chetaru.com/web-design/",
    "Description": "We build bespoke websites that are responsive, attractive, and functional",
    "Discount": "3 Month Hosting",
    "Does it drive you into a paid account": "Yes",
    "Requirement": "For Doctors / Hospital / any organization that's 100% dedicated to COVID-19 relief efforts",
    "Favicon": "",
    "How to apply (text)": "Contact us",
    "How to apply (URL or email)": "https://chetaru.com/contact/",
    "More info URL": ""
  },
  {
    "Name": "",
    "Approved": "",
    "Category": "Business Intelligence",
    "URL": "",
    "Description": "",
    "Discount": "",
    "Does it drive you into a paid account": "",
    "Requirement": "",
    "Favicon": "",
    "How to apply (text)": "",
    "How to apply (URL or email)": "",
    "More info URL": ""
  },
  {
    "Name": "Networks.bio",
    "Approved": "",
    "Category": "Social Media",
    "URL": "https://networks.bio",
    "Description": "",
    "Discount": "",
    "Does it drive you into a paid account": "",
    "Requirement": "",
    "Favicon": "",
    "How to apply (text)": "",
    "How to apply (URL or email)": "",
    "More info URL": ""
  },
  {
    "Name": "Trustely",
    "Approved": "",
    "Category": "eCommerce Software",
    "URL": "https://trustely.com/",
    "Description": "Trustely is an social proof app which helps you to increase your conversion rates and grow your website.",
    "Discount": "50% OFF on Lifetime Plan",
    "Does it drive you into a paid account": "Yes",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Register and head to pricing page and switch to lifetime plan enter the code: COVID50 and pay.",
    "How to apply (URL or email)": "https://app.trustely.com/pay/3",
    "More info URL": "https://trustely.com"
  },
  {
    "Name": "Satfever",
    "Approved": "",
    "Category": "Marketing Software",
    "URL": "https://app.myagency.club",
    "Description": "Free local marketing platform to help you manage your business and leads",
    "Discount": "30% OFF lifetime",
    "Does it drive you into a paid account": "yes",
    "Requirement": "None",
    "Favicon": "Register free account",
    "How to apply (text)": "",
    "How to apply (URL or email)": "https://app.myagency.club/",
    "More info URL": ""
  },
  {
    "Name": "Dumogio",
    "Approved": "",
    "Category": "Ads",
    "URL": "http://dumogio.com",
    "Description": "Dumogio help Brand & Marketer to embed Retargeting Pixel from Facebook, twitter, linkedin and more into shortened link. Dumogio help them to create super targeted ads and increase their ads conversion",
    "Discount": "50% OFF for lifetime",
    "Does it drive you into a paid account": "yes",
    "Requirement": "",
    "Favicon": "",
    "How to apply (text)": "Register and enter coupon code on billing page",
    "How to apply (URL or email)": "http://dumogio.com/",
    "More info URL": ""
  },
  {
    "Name": "JoyfulPerson",
    "Approved": "",
    "Category": "Microlearning",
    "URL": "www.joyfulperson.com",
    "Description": "text-based mobile micro-learning solution for frontline workers",
    "Discount": "1 month free for first time clients",
    "Does it drive you into a paid account": "yes",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "Drop us a note via our chatbot on our website, use discount code Joyful1",
    "How to apply (URL or email)": "www.joyfulperson.com",
    "More info URL": "www.joyfulperson.com"
  },
  {
    "Name": "WorkInSync",
    "Approved": "",
    "Category": "Business Planning",
    "URL": "https://www.workinsync.io/",
    "Description": "VACCINATION DRIVE : Are you also one of those organizations that are planning to vaccinate your employees and their dear ones?\nThen this is for you!\nTo support organizations in their employee vaccination programs, we at MoveInSync have developed a vaccination module which will enable this process.  Salient features: 1. Ability for employee to book vaccine appointment at office 2. Ability to define daily vaccine limit and slot wise capacity 3. Ability to include family members in booking 4. Report for admin  5. Employee can book vaccination and transport in same app",
    "Discount": "30% discount",
    "Does it drive you into a paid account": "yes",
    "Requirement": "None",
    "Favicon": "",
    "How to apply (text)": "email @ shevalli.bhushan@moveinsync.com",
    "How to apply (URL or email)": "shevalli.bhushan@moveinsync.com; mohit@moveinsync.com",
    "More info URL": "https://www.workinsync.io/"
  }
]